<div style="padding: 20px;" data-tour="company-general">
  <!-- Company Information Form -->
  <h2 data-tour-ready="company-general">{{ 'COMPANY_PAGE.TITLE' | translate }}</h2>
  <div class="company-form">
    <form nz-form [formGroup]="companyForm">
      <div nz-row nzGutter="16">
        <!-- LEFT: TABS -->
        <div
          nz-col
          [nzXs]="24"
          [nzSm]="24"
          [nzMd]="16"
          [nzLg]="16"
          [nzXl]="17"
          class="left-pane"
        >
          <nz-tabset class="company-tabs" [nzAnimated]="false" [(nzSelectedIndex)]="activeTabIndex">

            <!-- Tab title templates (icon + label) -->
            <ng-template #companyGeneralTitleTpl>
              <span nz-icon nzType="solution"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.TABS.GENERAL' | translate }} <span class="required-asterisk-after">*</span></span>
            </ng-template>

            <ng-template #companyAvailabilityTitleTpl>
              <span nz-icon nzType="clock-circle"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.TABS.AVAILABILITY' | translate }}</span>
            </ng-template>

            <ng-template #companyEmergencyTitleTpl>
              <span nz-icon nzType="alert"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.TABS.EMERGENCY_AVAILABILITY' | translate }}</span>
            </ng-template>

            <ng-template #companyHospLandingTitleTpl>
              <span nz-icon nzType="appstore"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.HOSPITALITY_TAB.LANDING_PREVIEW' | translate }}</span>
            </ng-template>

            <ng-template #companyHospHostContactTitleTpl>
              <span nz-icon nzType="user"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.HOSPITALITY_TAB.HOST_CONTACT' | translate }}</span>
            </ng-template>

            <ng-template #companyHospHouseRulesTitleTpl>
              <span nz-icon nzType="bulb"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.HOSPITALITY_TAB.HOUSE_RULES_GUIDES' | translate }}</span>
            </ng-template>

            <ng-template #companyHospFeedbackTitleTpl>
              <span nz-icon nzType="message"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FEEDBACK_CHANNEL' | translate }}</span>
            </ng-template>

            <ng-template #companyDisplayTitleTpl>
              <span nz-icon nzType="eye"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.TABS.DISPLAY' | translate }}</span>
            </ng-template>

            <ng-template #companyLinksTitleTpl>
              <span nz-icon nzType="link"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.TABS.LINKS' | translate }}</span>
            </ng-template>

            <ng-template #companyLandingProfilesTitleTpl>
              <span nz-icon nzType="apartment"></span>
              <span class="tab-title-text">{{ 'COMPANY_PAGE.TABS.LANDING_PROFILES' | translate }}</span>
            </ng-template>

            <!-- TAB: GENERAL -->
            <nz-tab [nzTitle]="companyGeneralTitleTpl">
              <div class="tab-body">
                <nz-form-item>
                  <nz-form-label [nzSpan]="8">
                    <span>{{ 'COMPANY_PAGE.COMPANY_NAME' | translate }}<span class="required-asterisk-after">*</span></span>
                    <span
                      nz-icon
                      nzType="info-circle"
                      class="info-icon"
                      nz-tooltip
                      [nzTooltipTitle]="'COMPANY_PAGE.COMPANY_NAME_READONLY_TOOLTIP' | translate"
                      style="margin-left: 6px; cursor: pointer;"
                    ></span>
                  </nz-form-label>

                  <nz-form-control [nzSpan]="16" [nzValidateStatus]="companyForm.get('companyName')!" [nzErrorTip]="companyNameErrTpl">
                    <input
                      nz-input
                      formControlName="companyName"
                      [attr.maxlength]="GENERAL_LIMITS.companyName"
                    />
                    <ng-template #companyNameErrTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        {{ 'COMPANY_PAGE.NAME_REQUIRED_ERROR' | translate }}
                      </ng-container>
                      <ng-container *ngIf="control.hasError('maxlength')">
                        {{ 'COMPANY_PAGE.MAX_CHAR_LIMIT_EXCEEDED' | translate:{ max: GENERAL_LIMITS.companyName } }}
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">
                    {{ 'COMPANY_PAGE.COMPANY_DISPLAY_EMAIL' | translate }}
                  </nz-form-label>

                  <nz-form-control [nzSpan]="16" [nzValidateStatus]="companyForm.get('companyDisplayEmail')!" [nzErrorTip]="companyEmailErrTpl">
                    <input
                      nz-input
                      formControlName="companyDisplayEmail"
                      [attr.maxlength]="GENERAL_LIMITS.email"
                    />
                    <ng-template #companyEmailErrTpl let-control>
                      <ng-container *ngIf="control.hasError('email')">
                        {{ 'COMPANY_PAGE.EMAIL_ERROR' | translate }}
                      </ng-container>
                      <ng-container *ngIf="control.hasError('maxlength')">
                        {{ 'COMPANY_PAGE.MAX_CHAR_LIMIT_EXCEEDED' | translate:{ max: GENERAL_LIMITS.email } }}
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.COMPANY_PHONE' | translate }}<span class="required-asterisk-after">*</span></nz-form-label>
                  <nz-form-control [nzSpan]="16" [nzValidateStatus]="companyForm.get('companyPhone')!" [nzErrorTip]="companyPhoneErrTpl">
                    <input
                      nz-input
                      formControlName="companyPhone"
                      [attr.maxlength]="GENERAL_LIMITS.phone"
                    />
                    <ng-template #companyPhoneErrTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        {{ 'COMPANY_PAGE.PHONE_REQUIRED_ERROR' | translate }}
                      </ng-container>
                      <ng-container *ngIf="control.hasError('invalidPhone')">
                        {{ 'COMPANY_PAGE.PHONE_ERROR' | translate }}
                      </ng-container>
                      <ng-container *ngIf="control.hasError('maxlength')">
                        {{ 'COMPANY_PAGE.MAX_CHAR_LIMIT_EXCEEDED' | translate:{ max: GENERAL_LIMITS.phone } }}
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.WHATSAPP_NUMBER' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16" [nzValidateStatus]="companyForm.get('whatsappNumber')!" [nzErrorTip]="whatsappNumberErrTpl">
                    <input
                      nz-input
                      formControlName="whatsappNumber"
                      [attr.maxlength]="GENERAL_LIMITS.whatsappNumber"
                    />
                    <div class="input-helper-text">
                      {{ 'COMPANY_PAGE.WHATSAPP_NUMBER_HELP' | translate }}
                    </div>
                    <ng-template #whatsappNumberErrTpl let-control>
                      <ng-container *ngIf="control.hasError('invalidWhatsAppNumber')">
                        {{ 'COMPANY_PAGE.WHATSAPP_NUMBER_ERROR' | translate }}
                      </ng-container>
                      <ng-container *ngIf="control.hasError('maxlength')">
                        {{ 'COMPANY_PAGE.MAX_CHAR_LIMIT_EXCEEDED' | translate:{ max: GENERAL_LIMITS.whatsappNumber } }}
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">
                    <span>{{ 'COMPANY_PAGE.COMPANY_ADDRESS' | translate }}<span class="required-asterisk-after">*</span></span>
                    <span
                      nz-icon
                      nzType="info-circle"
                      class="info-icon"
                      nz-popover
                      [nzPopoverTitle]="'COMMON.ADDRESS_FORMAT_HELP_TITLE' | translate"
                      [nzPopoverContent]="addressFormatPopover"
                      nzPopoverPlacement="rightTop"
                      nzPopoverOverlayClassName="address-format-popover"
                      style="margin-left: 6px; cursor: pointer;"
                    ></span>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="16" [nzValidateStatus]="companyForm.get('address')!" [nzErrorTip]="companyAddressErrTpl">
                    <input
                      nz-input
                      formControlName="address"
                      [attr.maxlength]="GENERAL_LIMITS.address"
                    />
                    <ng-template #companyAddressErrTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        {{ 'COMPANY_PAGE.ADDRESS_REQUIRED_ERROR' | translate }}
                      </ng-container>
                      <ng-container *ngIf="control.hasError('invalidAddress')">
                        {{ 'COMPANY_PAGE.ADDRESS_ERROR' | translate }}
                      </ng-container>
                      <ng-container *ngIf="control.hasError('maxlength')">
                        {{ 'COMPANY_PAGE.MAX_CHAR_LIMIT_EXCEEDED' | translate:{ max: GENERAL_LIMITS.address } }}
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.COMPANY_WEBSITE' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16" [nzValidateStatus]="companyForm.get('website')!" [nzErrorTip]="websiteErrTpl">
                    <input
                      nz-input
                      formControlName="website"
                      [attr.maxlength]="GENERAL_LIMITS.website"
                      [placeholder]="'COMPANY_PAGE.COMPANY_WEBSITE_PLACEHOLDER' | translate"
                    />
                    <div class="input-helper-text">
                      {{ 'COMPANY_PAGE.COMPANY_WEBSITE_HELP' | translate }}
                    </div>
                    <ng-template #websiteErrTpl let-control>
                      <ng-container *ngIf="control.hasError('invalidUrl')">
                        {{ 'COMPANY_PAGE.WEBSITE_ERROR' | translate }}
                      </ng-container>
                      <ng-container *ngIf="control.hasError('maxlength')">
                        {{ 'COMPANY_PAGE.MAX_CHAR_LIMIT_EXCEEDED' | translate:{ max: GENERAL_LIMITS.website } }}
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="!isHospitality">
                  <nz-form-label [nzSpan]="8" nzFor="publicLandingPageMessage">
                    <span>{{ 'COMPANY_PAGE.PUBLIC_LANDING_PAGE_NOTICE_LABEL' | translate }}</span>
                    <span
                      nz-icon
                      nzType="info-circle"
                      class="info-icon"
                      nz-tooltip
                      [nzTooltipTitle]="'COMPANY_PAGE.PUBLIC_LANDING_PAGE_NOTICE_HELP' | translate"
                      style="margin-left: 6px; cursor: pointer;"
                    ></span>
                  </nz-form-label>
                  <nz-form-control
                    [nzSpan]="16"
                    [nzValidateStatus]="companyForm.get('publicLandingPageMessage')!"
                    [nzErrorTip]="publicLandingPageMessageErrTpl"
                  >
                    <textarea
                      id="publicLandingPageMessage"
                      nz-input
                      formControlName="publicLandingPageMessage"
                      rows="4"
                      [attr.maxlength]="MAX_PUBLIC_LANDING_PAGE_MESSAGE"
                      [placeholder]="'COMPANY_PAGE.PUBLIC_LANDING_PAGE_NOTICE_PLACEHOLDER' | translate"
                      aria-describedby="publicLandingPageMessageCounter"
                    ></textarea>
                    <ng-template #publicLandingPageMessageErrTpl let-control>
                      <ng-container *ngIf="control.hasError('maxlength')">
                        {{ 'COMPANY_PAGE.MAX_CHAR_LIMIT_EXCEEDED' | translate:{ max: MAX_PUBLIC_LANDING_PAGE_MESSAGE } }}
                      </ng-container>
                    </ng-template>
                    <div
                      id="publicLandingPageMessageCounter"
                      class="char-counter"
                      style="margin-top:4px; font-size:12px; opacity:.8;"
                      aria-live="polite"
                    >
                      {{ 'COMPANY_PAGE.CHAR_COUNTER' | translate:{ current: publicLandingPageMessageLen, max: MAX_PUBLIC_LANDING_PAGE_MESSAGE } }}
                    </div>
                  </nz-form-control>
                </nz-form-item>

                <!-- Caretaker Text -->
                <nz-form-item *ngIf="!isHospitality">
                  <nz-form-label [nzSpan]="8">
                    <span>{{ 'COMPANY_PAGE.CARETAKER_TEXT' | translate }}<span class="required-asterisk-after">*</span></span>
                    <span
                      nz-icon
                      nzType="info-circle"
                      class="info-icon"
                      nz-tooltip
                      [nzTooltipTitle]="'COMPANY_PAGE.CARETAKER_TEXT_TOOLTIP' | translate"
                      style="margin-left: 6px; cursor: pointer;"
                    ></span>
                  </nz-form-label>
                  <nz-form-control
                    [nzSpan]="16"
                    [nzValidateStatus]="companyForm.get('caretakerText')!"
                    [nzErrorTip]="caretakerErrTpl"
                  >
                    <textarea
      nz-input
      formControlName="caretakerText"
      rows="4"
      [attr.maxlength]="MAX_CARETAKER_TEXT"
      aria-describedby="caretakerTextCounter"
    ></textarea>

                    <!-- error message -->
                    <ng-template #caretakerErrTpl>
      <span *ngIf="companyForm.get('caretakerText')?.hasError('required')">
        {{ 'COMPANY_PAGE.CARETAKER_TEXT_REQUIRED_ERROR' | translate }}
      </span>
                      <span *ngIf="companyForm.get('caretakerText')?.hasError('maxlength')">
        {{ 'COMPANY_PAGE.MAX_CHAR_LIMIT_EXCEEDED' | translate:{ max: MAX_CARETAKER_TEXT } }}
      </span>
                    </ng-template>

                    <!-- live counter -->
                    <div
                      id="caretakerTextCounter"
                      class="char-counter"
                      style="margin-top:4px; font-size:12px; opacity:.8;"
                      aria-live="polite"
                    >
                      {{ 'COMPANY_PAGE.CHAR_COUNTER' | translate:{ current: caretakerTextLen, max: MAX_CARETAKER_TEXT } }}
                    </div>
                  </nz-form-control>
                </nz-form-item>

                <!-- Technical Service Text -->
                <nz-form-item *ngIf="!isHospitality">
                  <nz-form-label [nzSpan]="8">
                    <span>{{ 'COMPANY_PAGE.TECHNICAL_SERVICE_TEXT' | translate }}<span class="required-asterisk-after">*</span></span>
                    <span
                      nz-icon
                      nzType="info-circle"
                      class="info-icon"
                      nz-tooltip
                      [nzTooltipTitle]="'COMPANY_PAGE.TECHNICAL_SERVICE_TEXT_TOOLTIP' | translate"
                      style="margin-left: 6px; cursor: pointer;"
                    ></span>
                  </nz-form-label>
                  <nz-form-control
                    [nzSpan]="16"
                    [nzValidateStatus]="companyForm.get('technicalServiceText')!"
                    [nzErrorTip]="techSvcErrTpl"
                  >
                    <textarea
      nz-input
      formControlName="technicalServiceText"
      rows="4"
      [attr.maxlength]="MAX_TECH_SERVICE_TEXT"
      aria-describedby="techServiceTextCounter"
    ></textarea>

                    <!-- error message -->
                    <ng-template #techSvcErrTpl>
      <span *ngIf="companyForm.get('technicalServiceText')?.hasError('required')">
        {{ 'COMPANY_PAGE.TECHNICAL_SERVICE_TEXT_REQUIRED_ERROR' | translate }}
      </span>
                      <span *ngIf="companyForm.get('technicalServiceText')?.hasError('maxlength')">
        {{ 'COMPANY_PAGE.MAX_CHAR_LIMIT_EXCEEDED' | translate:{ max: MAX_TECH_SERVICE_TEXT } }}
      </span>
                    </ng-template>

                    <!-- live counter -->
                    <div
                      id="techServiceTextCounter"
                      class="char-counter"
                      style="margin-top:4px; font-size:12px; opacity:.8;"
                      aria-live="polite"
                    >
                      {{ 'COMPANY_PAGE.CHAR_COUNTER' | translate:{ current: techServiceTextLen, max: MAX_TECH_SERVICE_TEXT } }}
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </nz-tab>

            <!-- TAB: AVAILABILITY -->
            <nz-tab *ngIf="!isHospitality" [nzTitle]="companyAvailabilityTitleTpl">
              <div class="tab-body">
                <nz-form-item>
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_AVAILABILITY' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label
                      nz-checkbox
                      formControlName="showAvailability"
                      (ngModelChange)="onShowAvailabilityChange($event)"
                    ></label>
                  </nz-form-control>
                </nz-form-item>
                <div class="info-section availability-warning" *ngIf="hasAnyAvailabilitySlotsFilled() && !companyForm.get('showAvailability')?.value">
                  <nz-alert
                    nzType="warning"
                    nzShowIcon
                    nzMessage="{{ 'COMPANY_PAGE.AVAILABILITY_HIDDEN_WARNING' | translate }}"
                  ></nz-alert>
                </div>
                <nz-form-item *ngFor="let day of weekDays; let di = index">
                  <nz-form-label [nzSpan]="8">
                    {{ ('COMPANY_PAGE.AVAILABILITY_' + (day | uppercase)) | translate }}
                  </nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <!-- slots for this day -->
                    <div [formArrayName]="day + 'Slots'">
                      <div
                        class="slot-row"
                        *ngFor="let slot of getDaySlots(day).controls; let i = index"
                        [formGroupName]="i"
                        style="display:flex; align-items:center; gap:8px; margin-bottom:8px;"
                      >
                        <nz-time-picker
                          formControlName="start"
                          nzFormat="HH:mm"
                          nzPlaceHolder="{{ 'COMPANY_PAGE.START_TIME' | translate }}"
                          (ngModelChange)="onSlotStartChange(day, i)"
                        ></nz-time-picker>
                        <span style="margin: 0 8px;">{{ 'COMPANY_PAGE.TO' | translate }}</span>
                        <nz-time-picker
                          formControlName="end"
                          nzFormat="HH:mm"
                          nzPlaceHolder="{{ 'COMPANY_PAGE.END_TIME' | translate }}"
                          [nzDisabledHours]="getDisabledEndHoursForSlot(day, i)"
                          [nzDisabledMinutes]="getDisabledEndMinutesForSlot(day, i)"
                          [nzDisabledSeconds]="getDisabledEndSecondsForSlot(day, i)"
                          (ngModelChange)="onSlotEndChange(day, i)"
                        ></nz-time-picker>

                        <button
                          nz-button
                          nzType="default"
                          nzShape="circle"
                          type="button"
                          (click)="removeSlot(day, i)"
                          [disabled]="slotsLen(day) === 1"
                          [attr.title]="'COMMON.REMOVE_TIME_RANGE' | translate"
                        >
                          <span nz-icon nzType="delete"></span>
                        </button>

                        <button
                          nz-button
                          nzType="dashed"
                          nzShape="circle"
                          type="button"
                          (click)="addSlot(day)"
                          [disabled]="slotsLen(day) >= 2"
                          [attr.title]="'COMMON.ADD_TIME_RANGE' | translate"
                        >
                          <span nz-icon nzType="plus"></span>
                        </button>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item *ngIf="companyForm.hasError('availabilityRequired')">
                  <nz-form-control [nzSpan]="16" nzOffset="8">
                    <div class="error-message">
                      {{ 'COMPANY_PAGE.ONE_DAY_AVAILABILITY_REQUIRED' | translate }}
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </nz-tab>

            <!-- TAB: EMERGENCY -->
            <nz-tab
              *ngIf="!isHospitality"
              [nzTitle]="companyEmergencyTitleTpl"
            >
              <div class="tab-body">
                <nz-form-item>
                  <nz-form-label [nzSpan]="8">
                    {{ 'COMPANY_PAGE.SHOW_EMERGENCY_AVAILABILITY' | translate }}
                  </nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label nz-checkbox formControlName="showEmergencyAvailability"></label>
                  </nz-form-control>
                </nz-form-item>
                <div class="info-section emergency-availability-warning" *ngIf="hasAnyEmergencyAvailabilitySlotsFilled() && !companyForm.get('showEmergencyAvailability')?.value">
                  <nz-alert
                    nzType="warning"
                    nzShowIcon
                    nzMessage="{{ 'COMPANY_PAGE.EMERGENCY_AVAILABILITY_HIDDEN_WARNING' | translate }}"
                  ></nz-alert>
                </div>
                <nz-form-item>
                  <nz-form-label [nzSpan]="8">
                    {{ 'COMPANY_PAGE.EMERGENCY_NUMBER' | translate }}<span class="required-asterisk-after" *ngIf="companyForm.get('showEmergencyAvailability')?.value">*</span>
                  </nz-form-label>
                  <nz-form-control
                    [nzSpan]="16"
                    [nzValidateStatus]="emergencyNumberCtrl"
                    [nzErrorTip]="emNumberErr"
                  >
                    <input
                      nz-input
                      formControlName="emergencyNumber"
                      placeholder="{{ 'COMPANY_PAGE.EMERGENCY_NUMBER' | translate }}"
                      [attr.maxlength]="GENERAL_LIMITS.emergencyNumber"
                    />
                    <ng-template #emNumberErr>
                  <span *ngIf="companyForm.get('emergencyNumber')?.hasError('required')">
                    {{ 'COMPANY_PAGE.EMERGENCY_PHONE_REQUIRED_ERROR' | translate }}
                  </span>
                      <span *ngIf="companyForm.get('emergencyNumber')?.hasError('invalidPhone')">
                    {{ 'COMPANY_PAGE.EMERGENCY_PHONE_ERROR' | translate }}
                  </span>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngFor="let day of emergencyWeekDays; let di = index">
                  <nz-form-label [nzSpan]="8">
                    {{ ('COMPANY_PAGE.AVAILABILITY_' + (day | uppercase)) | translate }}
                  </nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <div [formArrayName]="'Emergency' + day + 'Slots'">
                      <div
                        class="slot-row"
                        *ngFor="let slot of getDaySlots(day, true).controls; let i = index"
                        [formGroupName]="i"
                        style="display:flex; align-items:center; gap:8px; margin-bottom:8px;"
                      >
                        <nz-time-picker
                          formControlName="start"
                          nzFormat="HH:mm"
                          nzPlaceHolder="{{ 'COMPANY_PAGE.START_TIME' | translate }}"
                          (ngModelChange)="onSlotStartChange(day, i, true)"
                        ></nz-time-picker>
                        <span style="margin: 0 8px;">{{ 'COMPANY_PAGE.TO' | translate }}</span>
                        <nz-time-picker
                          formControlName="end"
                          nzFormat="HH:mm"
                          nzPlaceHolder="{{ 'COMPANY_PAGE.END_TIME' | translate }}"
                          [nzDisabledHours]="getDisabledEndHoursForSlot(day, i, true)"
                          [nzDisabledMinutes]="getDisabledEndMinutesForSlot(day, i, true)"
                          [nzDisabledSeconds]="getDisabledEndSecondsForSlot(day, i, true)"
                          (ngModelChange)="onSlotEndChange(day, i, true)"
                        ></nz-time-picker>

                        <button
                          nz-button
                          nzType="default"
                          nzShape="circle"
                          type="button"
                          (click)="removeSlot(day, i, true)"
                          [disabled]="slotsLen(day, true) === 1"
                          [attr.title]="'COMMON.REMOVE_TIME_RANGE' | translate"
                        >
                          <span nz-icon nzType="delete"></span>
                        </button>
                        <button
                          nz-button
                          nzType="dashed"
                          nzShape="circle"
                          type="button"
                          (click)="addSlot(day, true)"
                          [disabled]="slotsLen(day, true) >= 2"
                          [attr.title]="'COMMON.ADD_TIME_RANGE' | translate"
                        >
                          <span nz-icon nzType="plus"></span>
                        </button>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item *ngIf="companyForm.hasError('emergencyAvailabilityRequired')">
                  <nz-form-control [nzSpan]="16" nzOffset="8">
                    <div class="error-message">
                      {{ 'COMPANY_PAGE.ONE_DAY_EMERGENCY_AVAILABILITY_REQUIRED' | translate }}
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </nz-tab>

            <!-- TOP-LEVEL: Hospitality - Landing -->
            <nz-tab
              *ngIf="isHospitality"
              [nzTitle]="companyHospLandingTitleTpl"
            >
              <div class="tab-body" *ngIf="hospitalityLandingGroup as hospitalityLanding" [formGroup]="hospitalityLanding">
                <section class="hospitality-card">
                  <h3>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.LANDING_PREVIEW' | translate }}</h3>
                  <div class="hospitality-localized">
                    <label class="hospitality-label">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.WELCOME_MESSAGE' | translate }}
                    </label>
                    <textarea
                      nz-input
                      formControlName="welcomeMessage"
                      rows="2"
                      [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.welcomeMessage"
                    ></textarea>
                  </div>
                  <div class="hospitality-localized">
                    <label class="hospitality-label">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.GUEST_NOTES' | translate }}
                    </label>
                    <textarea
                      nz-input
                      formControlName="guestNotes"
                      rows="2"
                      [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.guestNotes"
                    ></textarea>
                  </div>
                </section>
              </div>
            </nz-tab>

            <!-- TOP-LEVEL: Hospitality - Host Contact -->
            <nz-tab
              *ngIf="isHospitality"
              [nzTitle]="companyHospHostContactTitleTpl"
            >
              <div class="tab-body" *ngIf="hospitalityLandingGroup as hospitalityLanding" [formGroup]="hospitalityLanding">
                <section class="hospitality-card" formGroupName="hostContact">
                  <h3>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.HOST_CONTACT' | translate }}</h3>
                  <nz-form-item>
                    <nz-form-label [nzSpan]="8">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.NAME' | translate }}
                    </nz-form-label>
                    <nz-form-control [nzSpan]="16">
                      <input
                        nz-input
                        formControlName="name"
                        [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.hostName"
                      />
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-label [nzSpan]="8">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.PHONE' | translate }}
                    </nz-form-label>
                    <nz-form-control [nzSpan]="16">
                      <input
                        nz-input
                        formControlName="phone"
                        [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.hostPhone"
                      />
                      <div
                        class="field-error"
                        *ngIf="
                          hospitalityLanding.get('hostContact.phone')?.errors?.['invalidPhone'] &&
                          (hospitalityLanding.get('hostContact.phone')?.dirty ||
                            hospitalityLanding.get('hostContact.phone')?.touched)
                        "
                      >
                        <span>
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.PHONE_INVALID' | translate }}
                        </span>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-label [nzSpan]="8">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.EMAIL' | translate }}
                    </nz-form-label>
                    <nz-form-control [nzSpan]="16">
                      <input
                        nz-input
                        formControlName="email"
                        [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.hostEmail"
                      />
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-label [nzSpan]="8">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.WHATSAPP' | translate }}
                    </nz-form-label>
                    <nz-form-control [nzSpan]="16">
                      <input
                        nz-input
                        formControlName="whatsapp"
                        [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.hostWhatsapp"
                      />
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-label [nzSpan]="8">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.SUPPORT_HOURS' | translate }}
                    </nz-form-label>
                    <nz-form-control [nzSpan]="16">
                      <div formArrayName="supportHoursSlots" class="hospitality-support-hours">
                        <div
                          class="support-hours-row"
                          *ngFor="let slotGroup of getHostSupportHourSlotControls(); let slotIndex = index"
                          [formGroupName]="slotIndex"
                        >
                          <nz-time-picker
                            formControlName="start"
                            nzFormat="HH:mm"
                            nzPlaceHolder="{{ 'COMPANY_PAGE.START_TIME' | translate }}"
                            (ngModelChange)="onHostSupportHourStartChange(slotIndex)"
                          ></nz-time-picker>
                          <span class="support-hours-separator">{{ 'COMPANY_PAGE.TO' | translate }}</span>
                          <nz-time-picker
                            formControlName="end"
                            nzFormat="HH:mm"
                            nzPlaceHolder="{{ 'COMPANY_PAGE.END_TIME' | translate }}"
                            [nzDisabledHours]="getDisabledHostSupportHourEndHours(slotIndex)"
                            [nzDisabledMinutes]="getDisabledHostSupportHourEndMinutes(slotIndex)"
                            [nzDisabledSeconds]="getDisabledHostSupportHourEndSeconds(slotIndex)"
                          ></nz-time-picker>
                          <button
                            nz-button
                            nzType="default"
                            nzShape="circle"
                            type="button"
                            (click)="removeHostSupportHourSlot(slotIndex)"
                            [disabled]="hostSupportHourSlotsLength() === 1"
                            [attr.title]="'COMMON.REMOVE_TIME_RANGE' | translate"
                          >
                            <span nz-icon nzType="delete"></span>
                          </button>
                          <button
                            nz-button
                            nzType="dashed"
                            nzShape="circle"
                            type="button"
                            (click)="addHostSupportHourSlot()"
                            [disabled]="hostSupportHourSlotsLength() >= 2"
                            [attr.title]="'COMMON.ADD_TIME_RANGE' | translate"
                          >
                            <span nz-icon nzType="plus"></span>
                          </button>
                        </div>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </section>
              </div>
            </nz-tab>

            <!-- TOP-LEVEL: Hospitality - House Rules & Guides -->
            <nz-tab
              *ngIf="isHospitality"
              [nzTitle]="companyHospHouseRulesTitleTpl"
            >
              <div class="tab-body" *ngIf="hospitalityEntriesGroup as hospitalityEntries" [formGroup]="hospitalityEntries">
                <ng-template
                  #catalogLinkDocumentTemplate
                  let-sectionKey="sectionKey"
                  let-entryIndex="entryIndex"
                  let-linkIndex="linkIndex"
                  let-linkGroup="linkGroup"
                >
                  <div class="catalog-link-document">
                    <nz-upload
                      nzName="file"
                      [nzShowUploadList]="false"
                      [nzMultiple]="false"
                      [nzCustomRequest]="hospitalityLinkDocumentUploadHandler(sectionKey, entryIndex, linkIndex)"
                      [nzDisabled]="isHospitalityLinkDocumentUploading(sectionKey, entryIndex, linkIndex)"
                    >
                      <button
                        nz-button
                        type="button"
                        [nzLoading]="isHospitalityLinkDocumentUploading(sectionKey, entryIndex, linkIndex)"
                      >
                        <span nz-icon nzType="upload"></span>
                        {{
                          linkGroup.get('document')?.value
                            ? ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.REPLACE_DOCUMENT' | translate)
                            : ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.UPLOAD_DOCUMENT' | translate)
                        }}
                      </button>
                    </nz-upload>
                    <div
                      class="catalog-link-document__details"
                      *ngIf="linkGroup.get('document')?.value as document"
                    >
                      <a
                        *ngIf="document.url"
                        class="catalog-link-document__link"
                        [href]="document.url"
                        target="_blank"
                        rel="noopener"
                      >
                        <span nz-icon nzType="file"></span>
                        {{ document.fileName || ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.VIEW_DOCUMENT' | translate) }}
                      </a>
                      <span
                        *ngIf="!document.url"
                        class="catalog-link-document__link"
                      >
                        <span nz-icon nzType="file"></span>
                        {{ document.fileName || ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.VIEW_DOCUMENT' | translate) }}
                      </span>
                      <span class="catalog-link-document__meta" *ngIf="document.fileType">
                        {{ document.fileType }}
                      </span>
                      <span class="catalog-link-document__meta" *ngIf="document.uploadedAt">
                        {{ 'COMPANY_PAGE.HOSPITALITY_TAB.DOCUMENT.UPLOADED' | translate }}
                        {{ document.uploadedAt | date: 'medium' }}
                      </span>
                      <button
                        nz-button
                        nzType="link"
                        type="button"
                        class="catalog-link-document__remove"
                        (click)="removeHospitalityLinkDocument(sectionKey, entryIndex, linkIndex)"
                        [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.REMOVE_DOCUMENT' | translate"
                      >
                        {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.REMOVE_DOCUMENT' | translate }}
                      </button>
                    </div>
                  </div>
                </ng-template>
                <!-- House rules -->
                <section class="hospitality-card" formArrayName="houseRules">
                  <ng-container *ngIf="getVisibleHospitalityControls('houseRules') as houseRulesEntries">
                    <nz-collapse class="catalog-section-collapse" [nzBordered]="false">
                      <ng-template #houseRulesHeader>
                        <header class="catalog-section-header">
                          <div class="catalog-section-header__title">
                            <h3>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.SECTIONS.HOUSE_RULES' | translate }}</h3>
                            <span class="catalog-section-count" *ngIf="houseRulesEntries.length">
                              {{ houseRulesEntries.length }}
                            </span>
                          </div>
                          <button
                            nz-button
                            nzType="dashed"
                            type="button"
                            (click)="$event.stopPropagation(); addHospitalityCatalogEntry('houseRules')"
                          >
                            <span nz-icon nzType="plus"></span>
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.ADD_HOUSE_RULE' | translate }}
                          </button>
                        </header>
                      </ng-template>
                      <nz-collapse-panel
                        [nzHeader]="houseRulesHeader"
                        [nzActive]="isHospitalitySectionExpanded('houseRules')"
                        (nzActiveChange)="onHospitalitySectionActiveChange('houseRules', $event)"
                      >
                        <p class="form-error" *ngIf="hasHospitalitySectionDuplicate('houseRules')">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.DUPLICATE_RULE' | translate:{ section: ('COMPANY_PAGE.HOSPITALITY_TAB.SECTIONS.HOUSE_RULES' | translate) } }}
                        </p>
                        <p class="catalog-empty" *ngIf="!houseRulesEntries.length">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.PREVIEW_EMPTY' | translate }}
                        </p>
                        <div
                          class="catalog-entry"
                          *ngFor="let entry of houseRulesEntries; let visibleIndex = index; trackBy: hospitalityEntryTrackBy"
                          [formGroupName]="entry.index"
                          [class.catalog-entry--editing]="isHospitalityEntryEditing('houseRules', entry.index)"
                        >
                        <div class="catalog-entry__header">
                          <strong>{{ entry.control.get('rule')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: visibleIndex + 1 }) }}</strong>
                          <div class="catalog-entry__actions">
                            <button
                              nz-button
                              nzType="link"
                              type="button"
                              (click)="toggleHospitalityEntryEditing('houseRules', entry.index)"
                              [attr.aria-expanded]="isHospitalityEntryEditing('houseRules', entry.index)"
                              [attr.aria-controls]="'houseRules-form-' + entry.index"
                            >
                              <span nz-icon [nzType]="isHospitalityEntryEditing('houseRules', entry.index) ? 'close' : 'edit'"></span>
                              {{ isHospitalityEntryEditing('houseRules', entry.index)
                                ? ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.CLOSE_EDITOR' | translate)
                                : ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.EDIT_ENTRY' | translate)
                              }}
                            </button>
                            <button
                              nz-button
                              nzType="link"
                              nzDanger
                              type="button"
                              (click)="removeHospitalityCatalogEntry('houseRules', entry.index)"
                              [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_ENTRY' | translate"
                            >
                              <span nz-icon nzType="delete"></span>
                            </button>
                          </div>
                        </div>
                        <div class="catalog-entry__preview" [attr.id]="'houseRules-preview-' + entry.index">
                          <p *ngIf="entry.control.get('rule')?.value" class="preview-summary">
                            {{ entry.control.get('rule')?.value }}
                          </p>
                          <div *ngIf="hospitalityCatalogLinks('houseRules', entry.index)?.length" class="preview-links">
                            <app-hospitality-link-preview
                              variant="list"
                              [links]="hospitalityCatalogLinks('houseRules', entry.index)?.value || []"
                            ></app-hospitality-link-preview>
                          </div>
                        </div>
                        <div
                          class="catalog-entry__collapse"
                          *ngIf="isHospitalityEntryEditing('houseRules', entry.index)"
                        >
                          <div class="catalog-entry__body" [attr.id]="'houseRules-form-' + entry.index">
                            <div class="form-field">
                              <label>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FIELDS.RULE' | translate }}</label>
                              <textarea
                                nz-input
                                formControlName="rule"
                                rows="3"
                                [attr.maxlength]="HOSPITALITY_LIMITS.rule"
                              ></textarea>
                              <div class="field-error" *ngIf="entry.control.get('rule')?.invalid && (entry.control.get('rule')?.dirty || entry.control.get('rule')?.touched)">
                                <span *ngIf="entry.control.get('rule')?.errors?.['required']">
                                  {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.REQUIRED' | translate }}
                                </span>
                                <span *ngIf="entry.control.get('rule')?.errors?.['maxlength']">
                                  {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.MAX_LENGTH' | translate:{ max: HOSPITALITY_LIMITS.rule } }}
                                </span>
                              </div>
                            </div>
                            <div formArrayName="links" class="catalog-links">
                              <div
                                class="catalog-link-row"
                                *ngFor="let linkCtrl of hospitalityCatalogLinks('houseRules', entry.index)?.controls; let linkIndex = index"
                                [formGroupName]="linkIndex"
                              >
                                <input
                                  nz-input
                                  formControlName="label"
                                  [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_LABEL' | translate"
                                  [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                                />
                                <input
                                  nz-input
                                  formControlName="url"
                                  [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_URL' | translate"
                                  [attr.maxlength]="HOSPITALITY_LIMITS.linkUrl"
                                />
                                <ng-container
                                  *ngTemplateOutlet="catalogLinkDocumentTemplate; context: {
                                    sectionKey: 'houseRules',
                                    entryIndex: entry.index,
                                    linkIndex: linkIndex,
                                    linkGroup: linkCtrl
                                  }"
                                ></ng-container>
                                <button
                                  nz-button
                                  nzType="link"
                                  type="button"
                                  (click)="removeHospitalityCatalogLink('houseRules', entry.index, linkIndex)"
                                  [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_LINK' | translate"
                                >
                                  <span nz-icon nzType="delete"></span>
                                </button>
                              </div>
                              <button
                                nz-button
                                nzType="dashed"
                                type="button"
                                (click)="addHospitalityCatalogLink('houseRules', entry.index)"
                              >
                                <span nz-icon nzType="plus"></span>
                                {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ADD_LINK' | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="catalog-entry catalog-entry--deleted"
                        *ngFor="let deletedEntry of getDeletedHospitalityControls('houseRules'); let deletedIndex = index; trackBy: hospitalityEntryTrackBy"
                      >
                        <span>
                          {{ deletedEntry.control.get('rule')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: deletedIndex + 1 }) }}
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.STATUS.DELETED' | translate }}
                        </span>
                        <button
                          nz-button
                          nzType="link"
                          type="button"
                          (click)="restoreHospitalityCatalogEntry('houseRules', deletedEntry.index)"
                        >
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.RESTORE' | translate }}
                        </button>
                      </div>
                      </nz-collapse-panel>
                    </nz-collapse>
                  </ng-container>
                </section>

                <!-- Check-ins -->
                <section class="hospitality-card" formArrayName="checkIns">
                  <ng-container *ngIf="getVisibleHospitalityControls('checkIns') as checkInsEntries">
                    <nz-collapse class="catalog-section-collapse" [nzBordered]="false">
                      <ng-template #checkInsHeader>
                        <header class="catalog-section-header">
                          <div class="catalog-section-header__title">
                            <h3>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.SECTIONS.CHECK_INS' | translate }}</h3>
                            <span class="catalog-section-count" *ngIf="checkInsEntries.length">
                              {{ checkInsEntries.length }}
                            </span>
                          </div>
                          <button
                            nz-button
                            nzType="dashed"
                            type="button"
                            (click)="$event.stopPropagation(); addHospitalityCatalogEntry('checkIns')"
                          >
                            <span nz-icon nzType="plus"></span>
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.ADD_CHECK_IN' | translate }}
                          </button>
                        </header>
                      </ng-template>
                      <nz-collapse-panel
                        [nzHeader]="checkInsHeader"
                        [nzActive]="isHospitalitySectionExpanded('checkIns')"
                        (nzActiveChange)="onHospitalitySectionActiveChange('checkIns', $event)"
                      >
                        <p class="form-error" *ngIf="hasHospitalitySectionDuplicate('checkIns')">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.DUPLICATE_TITLE' | translate:{ section: ('COMPANY_PAGE.HOSPITALITY_TAB.SECTIONS.CHECK_INS' | translate) } }}
                        </p>
                        <p class="catalog-empty" *ngIf="!checkInsEntries.length">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.PREVIEW_EMPTY' | translate }}
                        </p>
                        <div
                          class="catalog-entry"
                          *ngFor="let entry of checkInsEntries; let visibleIndex = index; trackBy: hospitalityEntryTrackBy"
                          [formGroupName]="entry.index"
                          [class.catalog-entry--editing]="isHospitalityEntryEditing('checkIns', entry.index)"
                        >
                      <div class="catalog-entry__header">
                        <strong>{{ entry.control.get('title')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: visibleIndex + 1 }) }}</strong>
                        <div class="catalog-entry__actions">
                          <button
                            nz-button
                            nzType="link"
                            type="button"
                            (click)="toggleHospitalityEntryEditing('checkIns', entry.index)"
                            [attr.aria-expanded]="isHospitalityEntryEditing('checkIns', entry.index)"
                            [attr.aria-controls]="'checkIns-form-' + entry.index"
                          >
                            <span nz-icon [nzType]="isHospitalityEntryEditing('checkIns', entry.index) ? 'close' : 'edit'"></span>
                            {{ isHospitalityEntryEditing('checkIns', entry.index)
                              ? ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.CLOSE_EDITOR' | translate)
                              : ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.EDIT_ENTRY' | translate)
                            }}
                          </button>
                          <button
                            nz-button
                            nzType="link"
                            nzDanger
                            type="button"
                            (click)="removeHospitalityCatalogEntry('checkIns', entry.index)"
                            [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_ENTRY' | translate"
                          >
                            <span nz-icon nzType="delete"></span>
                          </button>
                        </div>
                      </div>
                      <div class="catalog-entry__preview" [attr.id]="'checkIns-preview-' + entry.index">
                        <p *ngIf="entry.control.get('schedule')?.value as schedule" class="preview-meta" [hidden]="!(schedule?.from || schedule?.until)">
                          <span *ngIf="schedule?.from">
                            {{ 'HOSPITALITY_FIELDS.CHECK_IN_FROM' | translate }}:
                            {{ formatHospitalityPreviewTime(schedule?.from) || schedule?.from }}
                          </span>
                          <span *ngIf="schedule?.until">
                            <ng-container *ngIf="schedule?.from"> · </ng-container>
                            {{ 'HOSPITALITY_FIELDS.CHECK_IN_UNTIL' | translate }}:
                            {{ formatHospitalityPreviewTime(schedule?.until) || schedule?.until }}
                          </span>
                        </p>
                        <p *ngIf="entry.control.get('location')?.value" class="preview-meta">
                          {{ 'HOSPITALITY_FIELDS.CHECK_IN_LOCATION' | translate }}: {{ entry.control.get('location')?.value }}
                        </p>
                        <p *ngIf="entry.control.get('contact')?.value" class="preview-meta">
                          {{ 'HOSPITALITY_FIELDS.CHECK_IN_CONTACT' | translate }}: {{ entry.control.get('contact')?.value }}
                        </p>
                        <ng-container *ngIf="entry.control.get('instructions')?.value as instructions">
                          <p
                            *ngFor="let line of instructions.split('\n'); let idx = index"
                            class="preview-summary"
                            [hidden]="!line.trim()"
                          >
                            {{ line.trim() }}
                          </p>
                        </ng-container>
                        <div *ngIf="hospitalityCatalogLinks('checkIns', entry.index)?.length" class="preview-links">
                          <strong>{{ 'HOSPITALITY_FIELDS.CHECK_IN_LINKS' | translate }}</strong>
                          <app-hospitality-link-preview
                            variant="list"
                            [links]="hospitalityCatalogLinks('checkIns', entry.index)?.value || []"
                          ></app-hospitality-link-preview>
                        </div>
                        <div *ngIf="hospitalityCatalogDigitalKeys(entry.index)?.length" class="preview-digital-keys">
                          <strong>{{ 'HOSPITALITY_FIELDS.CHECK_IN_DIGITAL_KEYS' | translate }}</strong>
                          <ul>
                            <li *ngFor="let key of hospitalityCatalogDigitalKeys(entry.index)?.value" class="digital-key-preview">
                              <span class="digital-key-tag">
                                {{ ('HOSPITALITY_FIELDS.DIGITAL_KEY_OPTION_' + (key.accessType | uppercase)) | translate }}
                              </span>
                              <ng-container [ngSwitch]="key.accessType">
                                <span *ngSwitchCase="'pin'">{{ key.code }}</span>
                                <a
                                  *ngSwitchCase="'app'"
                                  [href]="key.link"
                                  target="_blank"
                                  rel="noopener"
                                >
                                  {{ key.link }}
                                </a>
                                <span *ngSwitchCase="'other'">{{ key.notes }}</span>
                              </ng-container>
                              <span *ngIf="key.notes && key.accessType === 'app'" class="muted">— {{ key.notes }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        class="catalog-entry__collapse"
                        *ngIf="isHospitalityEntryEditing('checkIns', entry.index)"
                      >
                        <div class="catalog-entry__body" [attr.id]="'checkIns-form-' + entry.index">
                              <div class="form-field">
                                <label>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FIELDS.TITLE' | translate }}</label>
                                <input nz-input formControlName="title" [attr.maxlength]="HOSPITALITY_LIMITS.title" />
                                <div class="field-error" *ngIf="entry.control.get('title')?.invalid && (entry.control.get('title')?.dirty || entry.control.get('title')?.touched)">
                                  <span *ngIf="entry.control.get('title')?.errors?.['required']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.REQUIRED' | translate }}
                                  </span>
                                  <span *ngIf="entry.control.get('title')?.errors?.['maxlength']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.MAX_LENGTH' | translate:{ max: HOSPITALITY_LIMITS.title } }}
                                  </span>
                                </div>
                              </div>
                              <div class="form-field">
                                <label>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FIELDS.INSTRUCTIONS' | translate }}</label>
                                <textarea
                                  nz-input
                                  formControlName="instructions"
                                  rows="3"
                                  [attr.maxlength]="HOSPITALITY_LIMITS.instructions"
                                ></textarea>
                                <div class="field-error" *ngIf="entry.control.get('instructions')?.invalid && (entry.control.get('instructions')?.dirty || entry.control.get('instructions')?.touched)">
                                  <span *ngIf="entry.control.get('instructions')?.errors?.['maxlength']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.MAX_LENGTH' | translate:{ max: HOSPITALITY_LIMITS.instructions } }}
                                  </span>
                                </div>
                              </div>
                              <div formGroupName="schedule" class="form-field-row schedule-fields">
                                <div class="form-field">
                                  <label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_FROM' | translate }}</label>
                                  <nz-time-picker
                                    formControlName="from"
                                    nzFormat="HH:mm"
                                    nzPlaceHolder="{{ 'COMPANY_PAGE.START_TIME' | translate }}"
                                    (ngModelChange)="onCheckInEntryStartChange(entry.index)"
                                  ></nz-time-picker>
                                </div>
                                <div class="form-field">
                                  <label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_UNTIL' | translate }}</label>
                                  <nz-time-picker
                                    formControlName="until"
                                    nzFormat="HH:mm"
                                    nzPlaceHolder="{{ 'COMPANY_PAGE.END_TIME' | translate }}"
                                    [nzDisabledHours]="getDisabledCheckInEntryUntilHours(entry.index)"
                                    [nzDisabledMinutes]="getDisabledCheckInEntryUntilMinutes(entry.index)"
                                    [nzDisabledSeconds]="getDisabledCheckInEntryUntilSeconds(entry.index)"
                                  ></nz-time-picker>
                                </div>
                              </div>
                              <div class="form-field-row">
                                <div class="form-field">
                                  <label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_LOCATION' | translate }}</label>
                                  <input
                                    nz-input
                                    formControlName="location"
                                    [attr.maxlength]="HOSPITALITY_LIMITS.location"
                                  />
                                  <div
                                    class="field-error"
                                    *ngIf="
                                      entry.control.get('location')?.errors?.['mapAddress'] &&
                                      (entry.control.get('location')?.dirty || entry.control.get('location')?.touched)
                                    "
                                  >
                                    <span>
                                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.LOCATION_INVALID' | translate }}
                                    </span>
                                  </div>
                                </div>
                                <div class="form-field">
                                  <label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_CONTACT' | translate }}</label>
                                  <input
                                    nz-input
                                    formControlName="contact"
                                    [attr.maxlength]="HOSPITALITY_LIMITS.contact"
                                  />
                                </div>
                              </div>
                              <div formArrayName="links" class="catalog-links">
                                <div
                                  class="catalog-link-row"
                                  *ngFor="let linkCtrl of hospitalityCatalogLinks('checkIns', entry.index)?.controls; let linkIndex = index"
                                  [formGroupName]="linkIndex"
                                >
                                  <input
                                    nz-input
                                    formControlName="label"
                                    [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_LABEL' | translate"
                                    [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                                  />
                                <input
                                  nz-input
                                  formControlName="url"
                                      [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_URL' | translate"
                                      [attr.maxlength]="HOSPITALITY_LIMITS.linkUrl"
                                    />
                                    <ng-container
                                      *ngTemplateOutlet="catalogLinkDocumentTemplate; context: {
                                        sectionKey: 'checkIns',
                                        entryIndex: entry.index,
                                        linkIndex: linkIndex,
                                        linkGroup: linkCtrl
                                      }"
                                    ></ng-container>
                                    <button
                                      nz-button
                                      nzType="link"
                                    type="button"
                                    (click)="removeHospitalityCatalogLink('checkIns', entry.index, linkIndex)"
                                    [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_LINK' | translate"
                                  >
                                    <span nz-icon nzType="delete"></span>
                                  </button>
                                </div>
                                <button
                                  nz-button
                                  nzType="dashed"
                                  type="button"
                                  (click)="addHospitalityCatalogLink('checkIns', entry.index)"
                                >
                                  <span nz-icon nzType="plus"></span>
                                  {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ADD_LINK' | translate }}
                                </button>
                              </div>
                              <div formArrayName="digitalKeys" class="catalog-links">
                                <div
                                  class="catalog-digital-key-row"
                                  *ngFor="let keyCtrl of hospitalityCatalogDigitalKeys(entry.index)?.controls; let keyIndex = index"
                                  [formGroupName]="keyIndex"
                                >
                                  <nz-select
                                    class="digital-key-access-select"
                                    formControlName="accessType"
                                    nzSize="small"
                                    [nzPlaceHolder]="'HOSPITALITY_FIELDS.DIGITAL_KEY_ACCESS_LABEL' | translate"
                                  >
                                    <nz-option
                                      *ngFor="let type of digitalKeyAccessTypes"
                                      [nzValue]="type"
                                      [nzLabel]="('HOSPITALITY_FIELDS.DIGITAL_KEY_OPTION_' + (type | uppercase)) | translate"
                                    ></nz-option>
                                  </nz-select>
                                  <div class="digital-key-value" [ngSwitch]="keyCtrl.get('accessType')?.value">
                                    <input
                                      *ngSwitchCase="'pin'"
                                      nz-input
                                      formControlName="code"
                                      [placeholder]="'HOSPITALITY_FIELDS.DIGITAL_KEY_CODE_PLACEHOLDER' | translate"
                                      [attr.maxlength]="HOSPITALITY_LIMITS.digitalKeyCode"
                                    />
                                    <input
                                      *ngSwitchCase="'app'"
                                      nz-input
                                      formControlName="link"
                                      type="url"
                                      [placeholder]="'HOSPITALITY_FIELDS.DIGITAL_KEY_LINK_PLACEHOLDER' | translate"
                                      [attr.maxlength]="HOSPITALITY_LIMITS.digitalKeyLink"
                                    />
                                    <textarea
                                      *ngSwitchCase="'other'"
                                      nz-input
                                      formControlName="notes"
                                      rows="2"
                                      [placeholder]="'HOSPITALITY_FIELDS.DIGITAL_KEY_NOTES_PLACEHOLDER' | translate"
                                      [attr.maxlength]="HOSPITALITY_LIMITS.digitalKeyNotes"
                                    ></textarea>
                                  </div>
                                  <button
                                    nz-button
                                    nzType="link"
                                    type="button"
                                    (click)="removeHospitalityCatalogDigitalKey(entry.index, keyIndex)"
                                    [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_LINK' | translate"
                                  >
                                    <span nz-icon nzType="delete"></span>
                                  </button>
                                  <div class="digital-key-helper">
                                    <small>{{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_HELPER' | translate }}</small>
                                    <div
                                      class="hospitality-error"
                                      *ngIf="keyCtrl.invalid && (keyCtrl.dirty || keyCtrl.touched)"
                                    >
                                      <ng-container *ngIf="keyCtrl.hasError('digitalKeyAccessRequired')">
                                        {{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_ACCESS_REQUIRED' | translate }}
                                      </ng-container>
                                    <ng-container *ngIf="keyCtrl.errors?.['digitalKeyValueRequired'] === 'code'">
                                      {{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_CODE_REQUIRED' | translate }}
                                    </ng-container>
                                    <ng-container *ngIf="keyCtrl.errors?.['digitalKeyValueRequired'] === 'link'">
                                      {{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_LINK_REQUIRED' | translate }}
                                    </ng-container>
                                    <ng-container *ngIf="keyCtrl.errors?.['digitalKeyValueRequired'] === 'notes'">
                                      {{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_NOTES_REQUIRED' | translate }}
                                    </ng-container>
                                    </div>
                                  </div>
                                </div>
                                <button
                                  nz-button
                                  nzType="dashed"
                                  type="button"
                                  (click)="addHospitalityCatalogDigitalKey(entry.index)"
                                >
                                  <span nz-icon nzType="plus"></span>
                                  {{ 'HOSPITALITY_FIELDS.ADD_DIGITAL_KEY' | translate }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                        class="catalog-entry catalog-entry--deleted"
                        *ngFor="let deletedEntry of getDeletedHospitalityControls('checkIns'); let deletedIndex = index; trackBy: hospitalityEntryTrackBy"
                      >
                          <span>
                            {{ deletedEntry.control.get('title')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: deletedIndex + 1 }) }}
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.STATUS.DELETED' | translate }}
                          </span>
                          <button
                            nz-button
                            nzType="link"
                            type="button"
                            (click)="restoreHospitalityCatalogEntry('checkIns', deletedEntry.index)"
                          >
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.RESTORE' | translate }}
                          </button>
                        </div>
                      </nz-collapse-panel>
                    </nz-collapse>
                  </ng-container>
                </section>
                <!-- Check-outs -->
                <section class="hospitality-card" formArrayName="checkOuts">
                  <ng-container *ngIf="getVisibleHospitalityControls('checkOuts') as checkOutsEntries">
                    <nz-collapse class="catalog-section-collapse" [nzBordered]="false">
                      <ng-template #checkOutsHeader>
                        <header class="catalog-section-header">
                          <div class="catalog-section-header__title">
                            <h3>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.SECTIONS.CHECK_OUTS' | translate }}</h3>
                            <span class="catalog-section-count" *ngIf="checkOutsEntries.length">
                              {{ checkOutsEntries.length }}
                            </span>
                          </div>
                          <button
                            nz-button
                            nzType="dashed"
                            type="button"
                            (click)="$event.stopPropagation(); addHospitalityCatalogEntry('checkOuts')"
                          >
                            <span nz-icon nzType="plus"></span>
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.ADD_CHECK_OUT' | translate }}
                          </button>
                        </header>
                      </ng-template>
                      <nz-collapse-panel
                        [nzHeader]="checkOutsHeader"
                        [nzActive]="isHospitalitySectionExpanded('checkOuts')"
                        (nzActiveChange)="onHospitalitySectionActiveChange('checkOuts', $event)"
                      >
                        <p class="form-error" *ngIf="hasHospitalitySectionDuplicate('checkOuts')">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.DUPLICATE_TITLE' | translate:{ section: ('COMPANY_PAGE.HOSPITALITY_TAB.SECTIONS.CHECK_OUTS' | translate) } }}
                        </p>
                        <p class="catalog-empty" *ngIf="!checkOutsEntries.length">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.PREVIEW_EMPTY' | translate }}
                        </p>
                        <div
                          class="catalog-entry"
                          *ngFor="let entry of checkOutsEntries; let visibleIndex = index; trackBy: hospitalityEntryTrackBy"
                          [formGroupName]="entry.index"
                          [class.catalog-entry--editing]="isHospitalityEntryEditing('checkOuts', entry.index)"
                        >
                      <div class="catalog-entry__header">
                        <strong>{{ entry.control.get('title')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: visibleIndex + 1 }) }}</strong>
                        <div class="catalog-entry__actions">
                          <button
                            nz-button
                            nzType="link"
                            type="button"
                            (click)="toggleHospitalityEntryEditing('checkOuts', entry.index)"
                            [attr.aria-expanded]="isHospitalityEntryEditing('checkOuts', entry.index)"
                            [attr.aria-controls]="'checkOuts-form-' + entry.index"
                          >
                            <span nz-icon [nzType]="isHospitalityEntryEditing('checkOuts', entry.index) ? 'close' : 'edit'"></span>
                            {{ isHospitalityEntryEditing('checkOuts', entry.index)
                              ? ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.CLOSE_EDITOR' | translate)
                              : ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.EDIT_ENTRY' | translate)
                            }}
                          </button>
                          <button
                            nz-button
                            nzType="link"
                            nzDanger
                            type="button"
                            (click)="removeHospitalityCatalogEntry('checkOuts', entry.index)"
                            [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_ENTRY' | translate"
                          >
                            <span nz-icon nzType="delete"></span>
                          </button>
                        </div>
                      </div>
                      <div class="catalog-entry__preview" [attr.id]="'checkOuts-preview-' + entry.index">
                        <p *ngIf="entry.control.get('checkOutTime')?.value" class="preview-meta">
                          {{ 'HOSPITALITY_FIELDS.CHECK_OUT_UNTIL' | translate }}:
                          {{ formatHospitalityPreviewTime(entry.control.get('checkOutTime')?.value) || entry.control.get('checkOutTime')?.value }}
                        </p>
                        <p *ngIf="entry.control.get('dropOffLocation')?.value" class="preview-meta">
                          {{ 'HOSPITALITY_FIELDS.CHECK_OUT_LOCATION' | translate }}: {{ entry.control.get('dropOffLocation')?.value }}
                        </p>
                        <p *ngIf="entry.control.get('contact')?.value" class="preview-meta">
                          {{ 'HOSPITALITY_FIELDS.CHECK_OUT_CONTACT' | translate }}: {{ entry.control.get('contact')?.value }}
                        </p>
                        <p *ngIf="entry.control.get('instructions')?.value" class="preview-summary">
                          {{ entry.control.get('instructions')?.value }}
                        </p>
                        <div *ngIf="hospitalityCatalogLinks('checkOuts', entry.index)?.length" class="preview-links">
                          <strong>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_LINKS' | translate }}</strong>
                          <app-hospitality-link-preview
                            variant="list"
                            [links]="hospitalityCatalogLinks('checkOuts', entry.index)?.value || []"
                          ></app-hospitality-link-preview>
                        </div>
                        <div *ngIf="hospitalityCatalogChecklist(entry.index)?.value as checklist" class="preview-checklist" [hidden]="!(checklist?.title || (checklist?.items?.length))">
                          <strong>{{ checklist?.title || ('HOSPITALITY_FIELDS.CHECK_OUT_TASKS' | translate) }}</strong>
                          <ul>
                            <li *ngFor="let task of (checklist?.items || [])" [hidden]="!(task && task.trim())">
                              {{ task }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        class="catalog-entry__collapse"
                        *ngIf="isHospitalityEntryEditing('checkOuts', entry.index)"
                      >
                        <div class="catalog-entry__body" [attr.id]="'checkOuts-form-' + entry.index">
                              <div class="form-field">
                                <label>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FIELDS.TITLE' | translate }}</label>
                                <input nz-input formControlName="title" [attr.maxlength]="HOSPITALITY_LIMITS.title" />
                                <div class="field-error" *ngIf="entry.control.get('title')?.invalid && (entry.control.get('title')?.dirty || entry.control.get('title')?.touched)">
                                  <span *ngIf="entry.control.get('title')?.errors?.['required']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.REQUIRED' | translate }}
                                  </span>
                                  <span *ngIf="entry.control.get('title')?.errors?.['maxlength']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.MAX_LENGTH' | translate:{ max: HOSPITALITY_LIMITS.title } }}
                                  </span>
                                </div>
                              </div>
                              <div class="form-field">
                                <label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_UNTIL' | translate }}</label>
                                <nz-time-picker
                                  formControlName="checkOutTime"
                                  nzFormat="HH:mm"
                                  nzPlaceHolder="{{ 'COMPANY_PAGE.END_TIME' | translate }}"
                                ></nz-time-picker>
                              </div>
                              <div class="form-field-row">
                                <div class="form-field">
                                  <label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_LOCATION' | translate }}</label>
                                  <input
                                    nz-input
                                    formControlName="dropOffLocation"
                                    [attr.maxlength]="HOSPITALITY_LIMITS.location"
                                  />
                                  <div
                                    class="field-error"
                                    *ngIf="
                                      entry.control.get('dropOffLocation')?.errors?.['mapAddress'] &&
                                      (entry.control.get('dropOffLocation')?.dirty || entry.control.get('dropOffLocation')?.touched)
                                    "
                                  >
                                    <span>
                                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.LOCATION_INVALID' | translate }}
                                    </span>
                                  </div>
                                </div>
                                <div class="form-field">
                                  <label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_CONTACT' | translate }}</label>
                                  <input
                                    nz-input
                                    formControlName="contact"
                                    [attr.maxlength]="HOSPITALITY_LIMITS.contact"
                                  />
                                </div>
                              </div>
                              <div class="form-field">
                                <label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_INSTRUCTIONS' | translate }}</label>
                                <textarea
                                  nz-input
                                  formControlName="instructions"
                                  rows="3"
                                  [attr.maxlength]="HOSPITALITY_LIMITS.instructions"
                                ></textarea>
                                <div
                                  class="field-error"
                                  *ngIf="entry.control.get('instructions')?.errors?.['maxlength'] && (entry.control.get('instructions')?.dirty || entry.control.get('instructions')?.touched)"
                                >
                                  <span>
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.MAX_LENGTH' | translate:{ max: HOSPITALITY_LIMITS.instructions } }}
                                  </span>
                                </div>
                              </div>
                              <div formArrayName="links" class="catalog-links">
                                <div
                                  class="catalog-link-row"
                                  *ngFor="let linkCtrl of hospitalityCatalogLinks('checkOuts', entry.index)?.controls; let linkIndex = index"
                                  [formGroupName]="linkIndex"
                                >
                                  <input
                                    nz-input
                                    formControlName="label"
                                    [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_LABEL' | translate"
                                    [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                                  />
                                <input
                                  nz-input
                                  formControlName="url"
                                      [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_URL' | translate"
                                      [attr.maxlength]="HOSPITALITY_LIMITS.linkUrl"
                                    />
                                    <ng-container
                                      *ngTemplateOutlet="catalogLinkDocumentTemplate; context: {
                                        sectionKey: 'checkOuts',
                                        entryIndex: entry.index,
                                        linkIndex: linkIndex,
                                        linkGroup: linkCtrl
                                      }"
                                    ></ng-container>
                                    <button
                                      nz-button
                                      nzType="link"
                                    type="button"
                                    (click)="removeHospitalityCatalogLink('checkOuts', entry.index, linkIndex)"
                                    [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_LINK' | translate"
                                  >
                                    <span nz-icon nzType="delete"></span>
                                  </button>
                                </div>
                                <button
                                  nz-button
                                  nzType="dashed"
                                  type="button"
                                  (click)="addHospitalityCatalogLink('checkOuts', entry.index)"
                                >
                                  <span nz-icon nzType="plus"></span>
                                  {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ADD_LINK' | translate }}
                                </button>
                              </div>
                              <div formGroupName="checklist" class="catalog-checklist">
                                <div class="form-field">
                                  <label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_CHECKLIST_TITLE' | translate }}</label>
                                  <input
                                    nz-input
                                    formControlName="title"
                                    [attr.maxlength]="HOSPITALITY_LIMITS.checklistTitle"
                                  />
                                </div>
                                <div formArrayName="items" class="catalog-checklist-items">
                                  <div
                                    class="catalog-link-row"
                                    *ngFor="let itemCtrl of hospitalityCatalogChecklistItems(entry.index)?.controls; let itemIndex = index"
                                  >
                                    <input
                                      nz-input
                                      [formControlName]="itemIndex"
                                      [attr.maxlength]="HOSPITALITY_LIMITS.checklistItem"
                                    />
                                    <button
                                      nz-button
                                      nzType="link"
                                      type="button"
                                      (click)="removeHospitalityCatalogChecklistItem(entry.index, itemIndex)"
                                      [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_ENTRY' | translate"
                                    >
                                      <span nz-icon nzType="delete"></span>
                                    </button>
                                  </div>
                                  <button
                                    nz-button
                                    nzType="dashed"
                                    type="button"
                                    (click)="addHospitalityCatalogChecklistItem(entry.index)"
                                  >
                                    <span nz-icon nzType="plus"></span>
                                    {{ 'HOSPITALITY_FIELDS.ADD_CHECKLIST_ITEM' | translate }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                        class="catalog-entry catalog-entry--deleted"
                        *ngFor="let deletedEntry of getDeletedHospitalityControls('checkOuts'); let deletedIndex = index; trackBy: hospitalityEntryTrackBy"
                      >
                          <span>
                            {{ deletedEntry.control.get('title')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: deletedIndex + 1 }) }}
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.STATUS.DELETED' | translate }}
                          </span>
                          <button
                            nz-button
                            nzType="link"
                            type="button"
                            (click)="restoreHospitalityCatalogEntry('checkOuts', deletedEntry.index)"
                          >
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.RESTORE' | translate }}
                          </button>
                        </div>
                      </nz-collapse-panel>
                    </nz-collapse>
                  </ng-container>
                </section>
                <!-- Appliance guides -->
                <section class="hospitality-card" formArrayName="applianceGuides">
                  <ng-container *ngIf="getVisibleHospitalityControls('applianceGuides') as applianceGuideEntries">
                    <nz-collapse class="catalog-section-collapse" [nzBordered]="false">
                      <ng-template #applianceGuidesHeader>
                        <header class="catalog-section-header">
                          <div class="catalog-section-header__title">
                            <h3>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.SECTIONS.APPLIANCE_GUIDES' | translate }}</h3>
                            <span class="catalog-section-count" *ngIf="applianceGuideEntries.length">
                              {{ applianceGuideEntries.length }}
                            </span>
                          </div>
                          <button
                            nz-button
                            nzType="dashed"
                            type="button"
                            (click)="$event.stopPropagation(); addHospitalityCatalogEntry('applianceGuides')"
                          >
                            <span nz-icon nzType="plus"></span>
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.ADD_APPLIANCE_GUIDE' | translate }}
                          </button>
                        </header>
                      </ng-template>
                      <nz-collapse-panel
                        [nzHeader]="applianceGuidesHeader"
                        [nzActive]="isHospitalitySectionExpanded('applianceGuides')"
                        (nzActiveChange)="onHospitalitySectionActiveChange('applianceGuides', $event)"
                      >
                        <p class="form-error" *ngIf="hasHospitalitySectionDuplicate('applianceGuides')">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.DUPLICATE_APPLIANCE' | translate }}
                        </p>
                        <p class="catalog-empty" *ngIf="!applianceGuideEntries.length">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.PREVIEW_EMPTY' | translate }}
                        </p>
                        <div
                          class="catalog-entry"
                          *ngFor="let entry of applianceGuideEntries; let visibleIndex = index; trackBy: hospitalityEntryTrackBy"
                          [formGroupName]="entry.index"
                          [class.catalog-entry--editing]="isHospitalityEntryEditing('applianceGuides', entry.index)"
                        >
                      <div class="catalog-entry__header">
                        <strong>{{ entry.control.get('appliance')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: visibleIndex + 1 }) }}</strong>
                        <div class="catalog-entry__actions">
                          <button
                            nz-button
                            nzType="link"
                            type="button"
                            (click)="toggleHospitalityEntryEditing('applianceGuides', entry.index)"
                            [attr.aria-expanded]="isHospitalityEntryEditing('applianceGuides', entry.index)"
                            [attr.aria-controls]="'applianceGuides-form-' + entry.index"
                          >
                            <span nz-icon [nzType]="isHospitalityEntryEditing('applianceGuides', entry.index) ? 'close' : 'edit'"></span>
                            {{ isHospitalityEntryEditing('applianceGuides', entry.index)
                              ? ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.CLOSE_EDITOR' | translate)
                              : ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.EDIT_ENTRY' | translate)
                            }}
                          </button>
                          <button
                            nz-button
                            nzType="link"
                            nzDanger
                            type="button"
                            (click)="removeHospitalityCatalogEntry('applianceGuides', entry.index)"
                            [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_ENTRY' | translate"
                          >
                            <span nz-icon nzType="delete"></span>
                          </button>
                        </div>
                      </div>
                      <div class="catalog-entry__preview" [attr.id]="'applianceGuides-preview-' + entry.index">
                        <p *ngIf="entry.control.get('summary')?.value" class="preview-summary">
                          {{ entry.control.get('summary')?.value }}
                        </p>
                        <ul *ngIf="(applianceGuideSteps(entry.index)?.value?.length)">
                          <li *ngFor="let step of applianceGuideSteps(entry.index)?.value" [hidden]="!(step || '').trim()">
                            {{ (step || '').trim() }}
                          </li>
                        </ul>
                        <div *ngIf="hospitalityCatalogLinks('applianceGuides', entry.index)?.length" class="preview-links">
                          <app-hospitality-link-preview
                            variant="list"
                            [links]="hospitalityCatalogLinks('applianceGuides', entry.index)?.value || []"
                          ></app-hospitality-link-preview>
                        </div>
                      </div>
                      <div
                        class="catalog-entry__collapse"
                        *ngIf="isHospitalityEntryEditing('applianceGuides', entry.index)"
                      >
                        <div class="catalog-entry__body" [attr.id]="'applianceGuides-form-' + entry.index">
                              <div class="form-field">
                                <label>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FIELDS.APPLIANCE' | translate }}</label>
                                <input nz-input formControlName="appliance" [attr.maxlength]="HOSPITALITY_LIMITS.appliance" />
                                <div class="field-error" *ngIf="entry.control.get('appliance')?.invalid && (entry.control.get('appliance')?.dirty || entry.control.get('appliance')?.touched)">
                                  <span *ngIf="entry.control.get('appliance')?.errors?.['required']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.REQUIRED' | translate }}
                                  </span>
                                  <span *ngIf="entry.control.get('appliance')?.errors?.['maxlength']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.MAX_LENGTH' | translate:{ max: HOSPITALITY_LIMITS.appliance } }}
                                  </span>
                                </div>
                              </div>
                              <div class="form-field">
                                <label>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FIELDS.SUMMARY' | translate }}</label>
                                <textarea
                                  nz-input
                                  formControlName="summary"
                                  rows="2"
                                  [attr.maxlength]="HOSPITALITY_LIMITS.summary"
                                ></textarea>
                                <div class="field-error" *ngIf="entry.control.get('summary')?.invalid && (entry.control.get('summary')?.dirty || entry.control.get('summary')?.touched)">
                                  <span *ngIf="entry.control.get('summary')?.errors?.['required']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.REQUIRED' | translate }}
                                  </span>
                                  <span *ngIf="entry.control.get('summary')?.errors?.['maxlength']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.MAX_LENGTH' | translate:{ max: HOSPITALITY_LIMITS.summary } }}
                                  </span>
                                </div>
                              </div>
                              <div class="form-field">
                                <label>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FIELDS.STEPS' | translate }}</label>
                                <div formArrayName="steps" class="catalog-steps">
                                  <div class="catalog-step-row" *ngFor="let stepCtrl of applianceGuideSteps(entry.index)?.controls; let stepIndex = index">
                                    <input
                                      nz-input
                                      [formControlName]="stepIndex"
                                      [attr.maxlength]="HOSPITALITY_LIMITS.details"
                                    />
                                    <button
                                      nz-button
                                      nzType="link"
                                      type="button"
                                      (click)="removeApplianceGuideStep(entry.index, stepIndex)"
                                      [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_STEP' | translate"
                                    >
                                      <span nz-icon nzType="delete"></span>
                                    </button>
                                  </div>
                                  <button nz-button nzType="dashed" type="button" (click)="addApplianceGuideStep(entry.index)">
                                    <span nz-icon nzType="plus"></span>
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.ADD_STEP' | translate }}
                                  </button>
                                </div>
                              </div>
                              <div formArrayName="links" class="catalog-links">
                                <div
                                  class="catalog-link-row"
                                  *ngFor="let linkCtrl of hospitalityCatalogLinks('applianceGuides', entry.index)?.controls; let linkIndex = index"
                                  [formGroupName]="linkIndex"
                                >
                                  <input
                                    nz-input
                                    formControlName="label"
                                    [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_LABEL' | translate"
                                    [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                                  />
                                <input
                                  nz-input
                                  formControlName="url"
                                      [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_URL' | translate"
                                      [attr.maxlength]="HOSPITALITY_LIMITS.linkUrl"
                                    />
                                    <ng-container
                                      *ngTemplateOutlet="catalogLinkDocumentTemplate; context: {
                                        sectionKey: 'applianceGuides',
                                        entryIndex: entry.index,
                                        linkIndex: linkIndex,
                                        linkGroup: linkCtrl
                                      }"
                                    ></ng-container>
                                    <button
                                      nz-button
                                      nzType="link"
                                    type="button"
                                    (click)="removeHospitalityCatalogLink('applianceGuides', entry.index, linkIndex)"
                                    [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_LINK' | translate"
                                  >
                                    <span nz-icon nzType="delete"></span>
                                  </button>
                                </div>
                                <button nz-button nzType="dashed" type="button" (click)="addHospitalityCatalogLink('applianceGuides', entry.index)">
                                  <span nz-icon nzType="plus"></span>
                                  {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ADD_LINK' | translate }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                        class="catalog-entry catalog-entry--deleted"
                        *ngFor="let deletedEntry of getDeletedHospitalityControls('applianceGuides'); let deletedIndex = index; trackBy: hospitalityEntryTrackBy"
                      >
                          <span>
                            {{ deletedEntry.control.get('appliance')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: deletedIndex + 1 }) }}
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.STATUS.DELETED' | translate }}
                          </span>
                          <button
                            nz-button
                            nzType="link"
                            type="button"
                            (click)="restoreHospitalityCatalogEntry('applianceGuides', deletedEntry.index)"
                          >
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.RESTORE' | translate }}
                          </button>
                        </div>
                      </nz-collapse-panel>
                    </nz-collapse>
                  </ng-container>
                </section>
                <!-- Additional information -->
                <section class="hospitality-card" formArrayName="additionalInfos" #additionalInfosSection>
                  <ng-container *ngIf="getVisibleHospitalityControls('additionalInfos') as additionalInfoEntries">
                    <nz-collapse class="catalog-section-collapse" [nzBordered]="false">
                      <ng-template #additionalInfosHeader>
                        <header class="catalog-section-header">
                          <div class="catalog-section-header__title">
                            <h3>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.SECTIONS.ADDITIONAL_INFO' | translate }}</h3>
                            <span class="catalog-section-count" *ngIf="additionalInfoEntries.length">
                              {{ additionalInfoEntries.length }}
                            </span>
                          </div>
                          <button
                            nz-button
                            nzType="dashed"
                            type="button"
                            (click)="$event.stopPropagation(); addHospitalityCatalogEntry('additionalInfos')"
                          >
                            <span nz-icon nzType="plus"></span>
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.ADD_ADDITIONAL_INFO' | translate }}
                          </button>
                        </header>
                      </ng-template>
                      <nz-collapse-panel
                        [nzHeader]="additionalInfosHeader"
                        [nzActive]="isHospitalitySectionExpanded('additionalInfos')"
                        (nzActiveChange)="onHospitalitySectionActiveChange('additionalInfos', $event)"
                      >
                        <p class="form-error" *ngIf="hasHospitalitySectionDuplicate('additionalInfos')">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.DUPLICATE_TITLE' | translate:{ section: ('COMPANY_PAGE.HOSPITALITY_TAB.SECTIONS.ADDITIONAL_INFO' | translate) } }}
                        </p>
                        <p class="catalog-empty" *ngIf="!additionalInfoEntries.length">
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.PREVIEW_EMPTY' | translate }}
                        </p>
                        <div
                          class="catalog-entry"
                          *ngFor="let entry of additionalInfoEntries; let visibleIndex = index; trackBy: hospitalityEntryTrackBy"
                          [formGroupName]="entry.index"
                          [class.catalog-entry--editing]="isHospitalityEntryEditing('additionalInfos', entry.index)"
                        >
                      <div class="catalog-entry__header">
                        <strong>{{ entry.control.get('title')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: visibleIndex + 1 }) }}</strong>
                        <div class="catalog-entry__actions">
                          <button
                            nz-button
                            nzType="link"
                            type="button"
                            (click)="toggleHospitalityEntryEditing('additionalInfos', entry.index)"
                            [attr.aria-expanded]="isHospitalityEntryEditing('additionalInfos', entry.index)"
                            [attr.aria-controls]="'additionalInfos-form-' + entry.index"
                          >
                            <span nz-icon [nzType]="isHospitalityEntryEditing('additionalInfos', entry.index) ? 'close' : 'edit'"></span>
                            {{ isHospitalityEntryEditing('additionalInfos', entry.index)
                              ? ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.CLOSE_EDITOR' | translate)
                              : ('COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.EDIT_ENTRY' | translate)
                            }}
                          </button>
                          <button
                            nz-button
                            nzType="link"
                            nzDanger
                            type="button"
                            (click)="removeHospitalityCatalogEntry('additionalInfos', entry.index)"
                            [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_ENTRY' | translate"
                          >
                            <span nz-icon nzType="delete"></span>
                          </button>
                        </div>
                      </div>
                      <div class="catalog-entry__preview" [attr.id]="'additionalInfos-preview-' + entry.index">
                        <p *ngIf="entry.control.get('body')?.value" class="preview-summary">
                          {{ entry.control.get('body')?.value }}
                        </p>
                        <div *ngIf="hospitalityCatalogLinks('additionalInfos', entry.index)?.length" class="preview-links">
                          <app-hospitality-link-preview
                            variant="list"
                            [links]="hospitalityCatalogLinks('additionalInfos', entry.index)?.value || []"
                          ></app-hospitality-link-preview>
                        </div>
                      </div>
                      <div
                        class="catalog-entry__collapse"
                        *ngIf="isHospitalityEntryEditing('additionalInfos', entry.index)"
                      >
                        <div class="catalog-entry__body" [attr.id]="'additionalInfos-form-' + entry.index">
                              <div class="form-field">
                                <label>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FIELDS.TITLE' | translate }}</label>
                                <input nz-input formControlName="title" [attr.maxlength]="HOSPITALITY_LIMITS.title" />
                                <div class="field-error" *ngIf="entry.control.get('title')?.invalid && (entry.control.get('title')?.dirty || entry.control.get('title')?.touched)">
                                  <span *ngIf="entry.control.get('title')?.errors?.['required']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.REQUIRED' | translate }}
                                  </span>
                                  <span *ngIf="entry.control.get('title')?.errors?.['maxlength']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.MAX_LENGTH' | translate:{ max: HOSPITALITY_LIMITS.title } }}
                                  </span>
                                </div>
                              </div>
                              <div class="form-field">
                                <label>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FIELDS.BODY' | translate }}</label>
                                <textarea
                                  nz-input
                                  formControlName="body"
                                  rows="3"
                                  [attr.maxlength]="HOSPITALITY_LIMITS.details"
                                ></textarea>
                                <div class="field-error" *ngIf="entry.control.get('body')?.invalid && (entry.control.get('body')?.dirty || entry.control.get('body')?.touched)">
                                  <span *ngIf="entry.control.get('body')?.errors?.['required']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.REQUIRED' | translate }}
                                  </span>
                                  <span *ngIf="entry.control.get('body')?.errors?.['maxlength']">
                                    {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.MAX_LENGTH' | translate:{ max: HOSPITALITY_LIMITS.details } }}
                                  </span>
                                </div>
                              </div>
                              <div formArrayName="links" class="catalog-links">
                                <div
                                  class="catalog-link-row"
                                  *ngFor="let linkCtrl of hospitalityCatalogLinks('additionalInfos', entry.index)?.controls; let linkIndex = index"
                                  [formGroupName]="linkIndex"
                                >
                                  <input
                                    nz-input
                                    formControlName="label"
                                    [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_LABEL' | translate"
                                    [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                                  />
                                <input
                                  nz-input
                                  formControlName="url"
                                      [placeholder]="'COMPANY_PAGE.HOSPITALITY_TAB.LINK_URL' | translate"
                                      [attr.maxlength]="HOSPITALITY_LIMITS.linkUrl"
                                    />
                                    <ng-container
                                      *ngTemplateOutlet="catalogLinkDocumentTemplate; context: {
                                        sectionKey: 'additionalInfos',
                                        entryIndex: entry.index,
                                        linkIndex: linkIndex,
                                        linkGroup: linkCtrl
                                      }"
                                    ></ng-container>
                                    <button
                                      nz-button
                                      nzType="link"
                                    type="button"
                                    (click)="removeHospitalityCatalogLink('additionalInfos', entry.index, linkIndex)"
                                    [attr.aria-label]="'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.DELETE_LINK' | translate"
                                  >
                                    <span nz-icon nzType="delete"></span>
                                  </button>
                                </div>
                                <button
                                  nz-button
                                  nzType="dashed"
                                  type="button"
                                  (click)="addHospitalityCatalogLink('additionalInfos', entry.index)"
                                >
                                  <span nz-icon nzType="plus"></span>
                                  {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ADD_LINK' | translate }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                        class="catalog-entry catalog-entry--deleted"
                        *ngFor="let deletedEntry of getDeletedHospitalityControls('additionalInfos'); let deletedIndex = index; trackBy: hospitalityEntryTrackBy"
                      >
                          <span>
                            {{ deletedEntry.control.get('title')?.value || ('COMPANY_PAGE.HOSPITALITY_TAB.UNTITLED_ENTRY' | translate:{ index: deletedIndex + 1 }) }}
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.STATUS.DELETED' | translate }}
                          </span>
                          <button
                            nz-button
                            nzType="link"
                            type="button"
                            (click)="restoreHospitalityCatalogEntry('additionalInfos', deletedEntry.index)"
                          >
                            {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ACTIONS.RESTORE' | translate }}
                          </button>
                        </div>
                      </nz-collapse-panel>
                    </nz-collapse>
                  </ng-container>
                </section>
              </div>
            </nz-tab>
            <!-- TOP-LEVEL: Hospitality - Feedback -->
            <nz-tab
              *ngIf="isHospitality"
              [nzTitle]="companyHospFeedbackTitleTpl"
            >
              <div class="tab-body" *ngIf="hospitalityLandingGroup as hospitalityLanding" [formGroup]="hospitalityLanding">
                <section class="hospitality-card" formGroupName="feedback">
                  <h3>{{ 'COMPANY_PAGE.HOSPITALITY_TAB.FEEDBACK_CHANNEL' | translate }}</h3>
                  <div class="hospitality-localized">
                    <label class="hospitality-label">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.INSTRUCTIONS' | translate }}
                    </label>
                    <textarea
                      nz-input
                      formControlName="instructions"
                      rows="2"
                      [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.feedbackInstructions"
                    ></textarea>
                  </div>
                  <nz-form-item>
                    <nz-form-label [nzSpan]="8">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.EMAIL' | translate }}
                    </nz-form-label>
                    <nz-form-control [nzSpan]="16">
                      <input
                        nz-input
                        formControlName="email"
                        [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.feedbackEmail"
                      />
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-label [nzSpan]="8">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.PHONE' | translate }}
                    </nz-form-label>
                    <nz-form-control [nzSpan]="16">
                      <input
                        nz-input
                        formControlName="phone"
                        [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.feedbackPhone"
                      />
                      <div
                        class="field-error"
                        *ngIf="
                          hospitalityLanding.get('feedback.phone')?.errors?.['invalidPhone'] &&
                          (hospitalityLanding.get('feedback.phone')?.dirty ||
                            hospitalityLanding.get('feedback.phone')?.touched)
                        "
                      >
                        <span>
                          {{ 'COMPANY_PAGE.HOSPITALITY_TAB.ERRORS.PHONE_INVALID' | translate }}
                        </span>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-label [nzSpan]="8">
                      {{ 'COMPANY_PAGE.HOSPITALITY_TAB.FORM_URL' | translate }}
                    </nz-form-label>
                    <nz-form-control [nzSpan]="16">
                      <input
                        nz-input
                        formControlName="formUrl"
                        [attr.maxlength]="HOSPITALITY_LANDING_LIMITS.feedbackFormUrl"
                      />
                    </nz-form-control>
                  </nz-form-item>
                </section>
              </div>
            </nz-tab>

            <!-- TAB: MANAGERS -->
            <nz-tab *ngIf="!isHospitality" [nzTitle]="companyDisplayTitleTpl">
              <div class="tab-body">
                <nz-form-item class="display-setting-divider">
                  <nz-form-control [nzSpan]="24">
                    <div class="display-setting-section-title">
                      {{ 'COMPANY_PAGE.DISPLAY_SECTION_LANDING_PAGE_MANAGERS' | translate }}
                    </div>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_PROPERTY_MANAGER' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label nz-checkbox formControlName="showPropertyManager" [nzDisabled]="!isManagerTypeConfigured('propertyManager')" [nz-tooltip]="!isManagerTypeConfigured('propertyManager') ? ('COMPANY_PAGE.TOOLTIP_MANAGER_NOT_CONFIGURED' | translate) : null"></label>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_TECHNICAL_ASSETS_MANAGER' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label nz-checkbox formControlName="showTechnicalAssetsManager" [nzDisabled]="!isManagerTypeConfigured('technicalAssetsManager')" [nz-tooltip]="!isManagerTypeConfigured('technicalAssetsManager') ? ('COMPANY_PAGE.TOOLTIP_MANAGER_NOT_CONFIGURED' | translate) : null"></label>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_CONDOMINIUM_MANAGER' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label nz-checkbox formControlName="showSevManager" [nzDisabled]="!isManagerTypeConfigured('sevManager')" [nz-tooltip]="!isManagerTypeConfigured('sevManager') ? ('COMPANY_PAGE.TOOLTIP_MANAGER_NOT_CONFIGURED' | translate) : null"></label>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_ACCOUNTANT' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label nz-checkbox formControlName="showAccountant" [nzDisabled]="!isManagerTypeConfigured('accountant')" [nz-tooltip]="!isManagerTypeConfigured('accountant') ? ('COMPANY_PAGE.TOOLTIP_MANAGER_NOT_CONFIGURED' | translate) : null"></label>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item class="display-setting-divider">
                  <nz-form-control [nzSpan]="24">
                    <div class="display-setting-section-title">
                      {{ 'COMPANY_PAGE.HOW_TO_REACH_US_MANAGER_SECTION' | translate }}
                    </div>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_MANAGER_IN_HOW_TO_REACH_US' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label nz-checkbox formControlName="showManagerInHowToReachUs" (nzCheckedChange)="onShowManagerInHowToReachUsChange($event)"></label>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="companyForm.get('showManagerInHowToReachUs')?.value">
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.HOW_TO_REACH_US_MANAGER_ORDER_LABEL' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <div
                      cdkDropList
                      class="how-to-reach-us-manager-order-list"
                      (cdkDropListDropped)="onHowToReachUsManagerOrderDrop($event)"
                    >
                      <div
                        *ngFor="let type of orderedManagerTypesForUI; let i = index"
                        class="how-to-reach-us-manager-order-item"
                        [class.how-to-reach-us-manager-order-item--included]="isManagerInHowToReachUsOrder(type)"
                        [class.how-to-reach-us-manager-order-item--unselected]="!isManagerInHowToReachUsOrder(type)"
                        [class.how-to-reach-us-manager-order-item--unavailable]="!isManagerTypeConfigured(type)"
                        cdkDrag
                        [cdkDragDisabled]="!isManagerInHowToReachUsOrder(type) || !isManagerTypeConfigured(type)"
                        (click)="isManagerTypeConfigured(type) && toggleManagerInHowToReachUsOrder(type)"
                      >
                        <i
                          *ngIf="isManagerInHowToReachUsOrder(type)"
                          nz-icon
                          nzType="menu"
                          class="how-to-reach-us-manager-order-drag-handle"
                          cdkDragHandle
                        ></i>
                        <label nz-checkbox
                          [nzChecked]="isManagerInHowToReachUsOrder(type)"
                          [nzDisabled]="!isManagerTypeConfigured(type)"
                          [nz-tooltip]="!isManagerTypeConfigured(type) ? ('COMPANY_PAGE.TOOLTIP_MANAGER_NOT_CONFIGURED' | translate) : null"
                          (click)="$event.stopPropagation()"
                          (nzCheckedChange)="isManagerTypeConfigured(type) && toggleManagerInHowToReachUsOrder(type)"
                        ></label>
                        <span class="how-to-reach-us-manager-order-item-label">
                          {{ 'COMPANY_PAGE.' + getManagerTypeLabelKey(type) | translate }}
                        </span>
                      </div>
                    </div>
                    <div class="how-to-reach-us-manager-order-hint">
                      {{ 'COMPANY_PAGE.DRAG_TO_REORDER' | translate }}
                    </div>
                    <div class="field-error" *ngIf="companyForm.get('howToReachUsManagerOrder')?.hasError('howToReachUsManagerOrderRequired')">
                      {{ 'COMPANY_PAGE.HOW_TO_REACH_US_MANAGER_ORDER_REQUIRED' | translate }}
                    </div>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item class="display-setting-divider">
                  <nz-form-control [nzSpan]="24">
                    <div class="display-setting-section-title">
                      {{ 'COMPANY_PAGE.DISPLAY_SECTION_EMERGENCY_HOTLINES' | translate }}
                    </div>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="appMode !== 'hospitality'">
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_EMERGENCY_NUMBERS_BOTH' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label
                      nz-checkbox
                      formControlName="showEmergencyNumbers"
                      (ngModelChange)="onShowEmergencyNumbersChange($event)"
                    ></label>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="appMode !== 'hospitality'" class="display-setting-form-item display-setting-form-item--poison">
                  <nz-form-control [nzSpan]="24">
                    <div class="display-setting-group display-setting-group--poison">
                      <div class="display-setting-row">
                        <div class="display-setting-row__label">
                          <div class="display-setting-row__label-text">
                            {{ 'COMPANY_PAGE.SHOW_POISON_INFO_CENTER_HOTLINE' | translate }}
                          </div>

                          <div class="nested-display-setting" *ngIf="companyForm.get('showPoisonInfoCenterHotline')?.value">
                            <label class="nested-display-setting__label" for="poisonInfoCenterHotlineNumber">
                              {{ 'COMPANY_PAGE.POISON_INFO_CENTER_HOTLINE_NUMBER_LABEL' | translate }}
                            </label>
                            <input
                              id="poisonInfoCenterHotlineNumber"
                              nz-input
                              formControlName="poisonInfoCenterHotlineNumber"
                              [placeholder]="'COMPANY_PAGE.POISON_INFO_CENTER_HOTLINE_NUMBER_PLACEHOLDER' | translate"
                              [attr.maxlength]="GENERAL_LIMITS.emergencyNumber"
                            />
                            <div
                              class="field-error"
                              *ngIf="
                                companyForm.get('poisonInfoCenterHotlineNumber')?.invalid &&
                                (companyForm.get('poisonInfoCenterHotlineNumber')?.dirty || companyForm.get('poisonInfoCenterHotlineNumber')?.touched)
                              "
                            >
                              <span *ngIf="companyForm.get('poisonInfoCenterHotlineNumber')?.hasError('required')">
                                {{ 'COMPANY_PAGE.POISON_INFO_CENTER_HOTLINE_NUMBER_REQUIRED_ERROR' | translate }}
                              </span>
                              <span *ngIf="companyForm.get('poisonInfoCenterHotlineNumber')?.hasError('invalidPhone')">
                                {{ 'COMPANY_PAGE.POISON_INFO_CENTER_HOTLINE_NUMBER_ERROR' | translate }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="display-setting-row__control">
                          <label nz-checkbox formControlName="showPoisonInfoCenterHotline"></label>
                        </div>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="appMode !== 'hospitality'" class="display-setting-form-item display-setting-form-item--poison">
                  <nz-form-control [nzSpan]="24">
                    <div class="display-setting-group display-setting-group--poison">
                      <div class="display-setting-row">
                        <div class="display-setting-row__label">
                          <div class="display-setting-row__label-text">
                            {{ 'COMPANY_PAGE.SHOW_VETERINARY_EMERGENCY_HOTLINE' | translate }}
                          </div>

                          <div class="nested-display-setting" *ngIf="companyForm.get('showVeterinaryEmergencyHotline')?.value">
                            <label class="nested-display-setting__label" for="veterinaryEmergencyHotlineNumber">
                              {{ 'COMPANY_PAGE.VETERINARY_EMERGENCY_HOTLINE_NUMBER_LABEL' | translate }}
                            </label>
                            <input
                              id="veterinaryEmergencyHotlineNumber"
                              nz-input
                              formControlName="veterinaryEmergencyHotlineNumber"
                              [placeholder]="'COMPANY_PAGE.VETERINARY_EMERGENCY_HOTLINE_NUMBER_PLACEHOLDER' | translate"
                              [attr.maxlength]="GENERAL_LIMITS.emergencyNumber"
                            />
                            <div
                              class="field-error"
                              *ngIf="
                                companyForm.get('veterinaryEmergencyHotlineNumber')?.invalid &&
                                (companyForm.get('veterinaryEmergencyHotlineNumber')?.dirty || companyForm.get('veterinaryEmergencyHotlineNumber')?.touched)
                              "
                            >
                              <span *ngIf="companyForm.get('veterinaryEmergencyHotlineNumber')?.hasError('required')">
                                {{ 'COMPANY_PAGE.VETERINARY_EMERGENCY_HOTLINE_NUMBER_REQUIRED_ERROR' | translate }}
                              </span>
                              <span *ngIf="companyForm.get('veterinaryEmergencyHotlineNumber')?.hasError('invalidPhone')">
                                {{ 'COMPANY_PAGE.VETERINARY_EMERGENCY_HOTLINE_NUMBER_ERROR' | translate }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="display-setting-row__control">
                          <label nz-checkbox formControlName="showVeterinaryEmergencyHotline"></label>
                        </div>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="appMode !== 'hospitality'">
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_TELEPHONE_COUNSELING_HOTLINE' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label nz-checkbox formControlName="showTelephoneCounselingHotline"></label>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="appMode !== 'hospitality'">
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_CHILDREN_YOUTH_HOTLINE' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label nz-checkbox formControlName="showChildrenYouthHotline"></label>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="appMode !== 'hospitality'">
                  <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.SHOW_WOMEN_GIRLS_EMERGENCY_HOTLINE' | translate }}</nz-form-label>
                  <nz-form-control [nzSpan]="16">
                    <label nz-checkbox formControlName="showWomenGirlsEmergencyHotline"></label>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="appMode !== 'hospitality'" class="display-setting-form-item">
                  <nz-form-control [nzSpan]="24">
                    <div class="display-setting-group">
                      <div class="display-setting-row">
                        <div class="display-setting-row__label">
                          <div class="display-setting-row__label-text">
                            {{ 'COMPANY_PAGE.LANDING_PAGE_EMERGENCY_SERVICE_PLACEMENT_TITLE' | translate }}
                            <span
                              nz-icon
                              nzType="info-circle"
                              class="info-icon"
                              nz-tooltip
                              [nzTooltipTitle]="'COMPANY_PAGE.LANDING_PAGE_EMERGENCY_SERVICE_PLACEMENT_DESCRIPTION' | translate"
                              style="margin-left: 6px; cursor: pointer;"
                            ></span>
                          </div>
                        </div>
                        <div class="display-setting-row__control">
                          <nz-switch formControlName="landingPageEmergencyServicePlacementEnabled"></nz-switch>
                        </div>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>

                <div class="form-hint">
                  <span nz-icon nzType="eye" class="form-hint-icon"></span>
                  <span class="form-hint-text">{{ 'COMPANY_PAGE.DISPLAY_TAB_HINT' | translate }}</span>
                </div>
              </div>
            </nz-tab>

            <nz-tab *ngIf="!isHospitality" [nzTitle]="companyLandingProfilesTitleTpl">
              <div class="tab-body">
                <div class="landing-profiles-toolbar">
                  <div class="landing-profiles-toggle-card">
                    <div class="landing-profiles-toggle-text">
                      <strong>{{ 'COMPANY_PAGE.LANDING_PROFILES.SECTION_TITLE' | translate }}</strong>
                      <span>{{ 'COMPANY_PAGE.LANDING_PROFILES.DESCRIPTION' | translate }}</span>
                    </div>
                    <nz-switch formControlName="multiLandingProfilesEnabled"></nz-switch>
                  </div>
                  <button nz-button nzType="primary" type="button" *ngIf="landingProfilesEnabled" (click)="startCreateLandingProfile()">
                    <span nz-icon nzType="plus"></span>
                    {{ 'COMPANY_PAGE.LANDING_PROFILES.CREATE' | translate }}
                  </button>
                </div>

                <p class="landing-profile-intro__hint">{{ 'COMPANY_PAGE.LANDING_PROFILES.FALLBACK_HINT' | translate }}</p>

                <nz-alert
                  *ngIf="!landingProfilesEnabled"
                  nzType="info"
                  [nzMessage]="'COMPANY_PAGE.LANDING_PROFILES.DISABLED_TITLE' | translate"
                  [nzDescription]="'COMPANY_PAGE.LANDING_PROFILES.DISABLED_DESCRIPTION' | translate"
                  nzShowIcon
                ></nz-alert>

                <ng-container *ngIf="landingProfilesEnabled">
                  <div *ngIf="landingProfilesLoading" class="input-helper-text">
                    {{ 'COMPANY_PAGE.LANDING_PROFILES.LOADING' | translate }}
                  </div>

                  <div *ngIf="!landingProfilesLoading && !landingProfiles.length" class="input-helper-text">
                    {{ 'COMPANY_PAGE.LANDING_PROFILES.EMPTY' | translate }}
                  </div>

                  <div class="landing-profile-list" *ngIf="!landingProfilesLoading && landingProfiles.length">
                    <div *ngFor="let profile of landingProfiles" class="landing-profile-card">
                      <div class="landing-profile-card__header">
                      <div>
                          <strong>{{ profile.profileName }}</strong>
                          <div class="landing-profile-card__subtitle" *ngIf="profile.name">{{ profile.name }}</div>
                        </div>
                        <div class="landing-profile-card__badges">
                          <nz-tag [nzColor]="profile.active === false ? 'default' : 'green'">
                            {{ (profile.active === false ? 'COMPANY_PAGE.LANDING_PROFILES.INACTIVE' : 'COMPANY_PAGE.LANDING_PROFILES.ACTIVE') | translate }}
                          </nz-tag>
                        </div>
                      </div>

                      <div class="landing-profile-card__details">
                        <span *ngIf="profile.phone">{{ profile.phone }}</span>
                        <span *ngIf="profile.email">{{ profile.email }}</span>
                        <span *ngIf="profile.address">{{ profile.address }}</span>
                      </div>

                      <div class="landing-profile-card__actions">
                        <button nz-button nzType="default" type="button" (click)="editLandingProfile(profile)">
                          <span nz-icon nzType="edit"></span>
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.EDIT' | translate }}
                        </button>
                        <button nz-button nzType="default" nzDanger type="button" *ngIf="profile.active !== false" (click)="deactivateLandingProfile(profile)">
                          <span nz-icon nzType="delete"></span>
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.DELETE' | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </nz-tab>

            <!-- TAB: APPEARANCE & LINKS -->
            <nz-tab *ngIf="!isHospitality" [nzTitle]="companyLinksTitleTpl">
              <div class="tab-body">
                <!-- QUICK LINKS (unchanged markup, just living inside this tab) -->
                <div formArrayName="quickLinks" class="quick-links-form">
                  <div class="quick-links-header">
                    <span nz-icon nzType="link" class="icon-theme"></span>
                    <div>
                      <h3>{{ 'COMPANY_PAGE.QUICK_LINKS_FORM_TITLE' | translate }}</h3>
                      <p>{{ 'COMPANY_PAGE.QUICK_LINKS_FORM_DESCRIPTION' | translate }}</p>
                    </div>
                  </div>

                  <div
                    class="quick-link-group"
                    *ngFor="let linkGroup of quickLinks.controls; let i = index"
                    [formGroupName]="i"
                  >
                    <div nz-row nzGutter="12" nzAlign="middle" class="quick-link-row">
                      <div nz-col nzSpan="10">
                        <nz-form-item>
                          <nz-form-label class="quick-link-label">{{ 'COMPANY_PAGE.QUICK_LINK_LABEL' | translate }}</nz-form-label>
                          <nz-form-control [nzValidateStatus]="linkGroup.get('label')!" [nzErrorTip]="labelErr">
                            <input
                              nz-input
                              formControlName="label"
                              [attr.maxlength]="GENERAL_LIMITS.quickLinkLabel"
                            />
                            <ng-template #labelErr>
                              <span>{{ 'COMPANY_PAGE.QUICK_LINK_LABEL' | translate }} {{ 'COMMON.REQUIRED' | translate }}</span>
                            </ng-template>
                          </nz-form-control>
                        </nz-form-item>
                      </div>

                      <div nz-col nzSpan="10">
                        <nz-form-item>
                          <nz-form-label class="quick-link-label">{{ 'COMPANY_PAGE.QUICK_LINK_URL' | translate }}</nz-form-label>
                          <nz-form-control [nzValidateStatus]="linkGroup.get('url')!" [nzErrorTip]="urlErr">
                            <input
                              nz-input
                              formControlName="url"
                              [attr.maxlength]="GENERAL_LIMITS.quickLinkUrl"
                            />
                            <ng-template #urlErr>
                          <span *ngIf="linkGroup.get('url')?.hasError('required')">
                            {{ 'COMPANY_PAGE.QUICK_LINK_URL' | translate }} {{ 'COMMON.REQUIRED' | translate }}
                          </span>
                              <span *ngIf="linkGroup.get('url')?.hasError('invalidUrl')">
                            {{ 'COMPANY_PAGE.WEBSITE_ERROR' | translate }}
                          </span>
                            </ng-template>
                          </nz-form-control>
                        </nz-form-item>
                      </div>

                      <div nz-col nzSpan="4" class="quick-link-actions">
                        <button
                          nz-button
                          nzType="default"
                          nzShape="circle"
                          type="button"
                          (click)="removeQuickLink(i)"
                        >
                          <span nz-icon nzType="delete"></span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <button
                    nz-button
                    nzType="dashed"
                    type="button"
                    class="quick-link-add"
                    (click)="addQuickLink()"
                    [disabled]="!canAddQuickLink()"
                  >
                    <span nz-icon nzType="plus"></span>
                    {{ 'COMPANY_PAGE.ADD_QUICK_LINK' | translate }}
                  </button>

                  <div class="form-hint">
                    <span nz-icon nzType="bulb"></span>
                    {{ 'COMPANY_PAGE.QUICK_LINKS_PREVIEW_NOTE' | translate }}
                  </div>

                  <div class="error-message" *ngIf="quickLinks.invalid && (quickLinks.touched || quickLinks.dirty)">
                    {{ 'COMPANY_PAGE.QUICK_LINKS_INCOMPLETE_ERROR' | translate }}
                  </div>
                </div>
              </div>
            </nz-tab>
          </nz-tabset>

          <nz-modal
            [(nzVisible)]="landingProfileModalVisible"
            [nzTitle]="editingLandingProfileId ? ('COMPANY_PAGE.LANDING_PROFILES.EDIT' | translate) : ('COMPANY_PAGE.LANDING_PROFILES.CREATE' | translate)"
            [nzOkLoading]="landingProfileSaving"
            [nzOkText]="'COMMON.SAVE' | translate"
            [nzCancelText]="'COMMON.CANCEL' | translate"
            (nzOnCancel)="cancelLandingProfileEdit()"
            (nzOnOk)="saveLandingProfile()"
          >
            <ng-container *nzModalContent>
              <form nz-form nzLayout="vertical" [formGroup]="landingProfileForm" class="edit-form-grid landing-profile-modal-form">
                <div class="landing-profile-modal-section">
                  <h4>{{ 'COMPANY_PAGE.LANDING_PROFILES.BASIC_INFO' | translate }}</h4>
                  <div class="landing-profile-modal-grid">
                    <nz-form-item class="landing-profile-modal-field">
                      <nz-form-label>{{ 'COMPANY_PAGE.LANDING_PROFILES.PROFILE_NAME' | translate }}<span class="required-asterisk-after">*</span></nz-form-label>
                      <nz-form-control [nzValidateStatus]="landingProfileForm.get('profileName')!">
                        <input nz-input formControlName="profileName" [attr.maxlength]="LANDING_PROFILE_LIMITS.profileName" />
                        <div class="field-error" *ngIf="hasLandingProfileFieldError('profileName', 'required')">
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.PROFILE_NAME_REQUIRED' | translate }}
                        </div>
                        <div class="field-error" *ngIf="hasLandingProfileFieldError('profileName', 'minlength')">
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.PROFILE_NAME_MIN_LENGTH' | translate:{ min: 2 } }}
                        </div>
                      </nz-form-control>
                    </nz-form-item>

                    <nz-form-item class="landing-profile-modal-field">
                      <nz-form-label>{{ 'COMPANY_PAGE.LANDING_PROFILES.DISPLAY_NAME' | translate }}<span class="required-asterisk-after">*</span></nz-form-label>
                      <nz-form-control [nzValidateStatus]="landingProfileForm.get('name')!">
                        <input nz-input formControlName="name" [attr.maxlength]="LANDING_PROFILE_LIMITS.name" />
                        <div class="field-error" *ngIf="hasLandingProfileFieldError('name', 'required')">
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.DISPLAY_NAME_REQUIRED' | translate }}
                        </div>
                        <div class="field-error" *ngIf="hasLandingProfileFieldError('name', 'minlength')">
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.DISPLAY_NAME_MIN_LENGTH' | translate:{ min: 2 } }}
                        </div>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>

                <div class="landing-profile-modal-section">
                  <h4>{{ 'COMPANY_PAGE.LANDING_PROFILES.CONTACT_DETAILS' | translate }}</h4>
                  <div class="landing-profile-modal-grid">
                    <nz-form-item class="landing-profile-modal-field">
                      <nz-form-label>{{ 'COMPANY_PAGE.COMPANY_PHONE' | translate }}<span class="required-asterisk-after">*</span></nz-form-label>
                      <nz-form-control [nzValidateStatus]="landingProfileForm.get('phone')!">
                        <input nz-input formControlName="phone" [attr.maxlength]="LANDING_PROFILE_LIMITS.phone" />
                        <div class="field-error" *ngIf="hasLandingProfileFieldError('phone', 'required')">
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.PHONE_REQUIRED' | translate }}
                        </div>
                        <div class="field-error" *ngIf="hasLandingProfileFieldError('phone', 'invalidPhone')">
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.PHONE_ERROR' | translate }}
                        </div>
                      </nz-form-control>
                    </nz-form-item>

                    <nz-form-item class="landing-profile-modal-field">
                      <nz-form-label>{{ 'COMPANY_PAGE.COMPANY_DISPLAY_EMAIL' | translate }}</nz-form-label>
                      <nz-form-control [nzValidateStatus]="landingProfileForm.get('email')!">
                        <input nz-input formControlName="email" [attr.maxlength]="LANDING_PROFILE_LIMITS.email" />
                        <div class="field-error" *ngIf="hasLandingProfileFieldError('email', 'email')">
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.EMAIL_ERROR' | translate }}
                        </div>
                      </nz-form-control>
                    </nz-form-item>

                    <nz-form-item class="landing-profile-modal-field">
                      <nz-form-label>{{ 'COMPANY_PAGE.COMPANY_WEBSITE' | translate }}</nz-form-label>
                      <nz-form-control [nzValidateStatus]="landingProfileForm.get('website')!">
                        <input nz-input formControlName="website" [attr.maxlength]="LANDING_PROFILE_LIMITS.website" />
                        <div class="field-error" *ngIf="hasLandingProfileFieldError('website', 'invalidUrl')">
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.WEBSITE_ERROR' | translate }}
                        </div>
                      </nz-form-control>
                    </nz-form-item>

                    <nz-form-item class="landing-profile-modal-field">
                      <nz-form-label>{{ 'COMPANY_PAGE.EMERGENCY_NUMBER' | translate }}</nz-form-label>
                      <nz-form-control [nzValidateStatus]="landingProfileForm.get('emergencyNumber')!">
                        <input nz-input formControlName="emergencyNumber" [attr.maxlength]="LANDING_PROFILE_LIMITS.emergencyNumber" />
                        <div class="field-error" *ngIf="hasLandingProfileFieldError('emergencyNumber', 'invalidPhone')">
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.EMERGENCY_PHONE_ERROR' | translate }}
                        </div>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>

                <div class="landing-profile-modal-section">
                  <h4>{{ 'COMPANY_PAGE.LANDING_PROFILES.ADDRESS_SECTION' | translate }}</h4>
                  <nz-form-item class="landing-profile-modal-field">
                    <nz-form-label>{{ 'COMPANY_PAGE.COMPANY_ADDRESS' | translate }}</nz-form-label>
                    <nz-form-control [nzValidateStatus]="landingProfileForm.get('address')!">
                      <input nz-input formControlName="address" [attr.maxlength]="LANDING_PROFILE_LIMITS.address" />
                      <div class="field-error" *ngIf="hasLandingProfileFieldError('address', 'invalidAddress')">
                        {{ 'COMPANY_PAGE.LANDING_PROFILES.ADDRESS_ERROR' | translate }}
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </div>

                <div class="landing-profile-modal-section">
                  <h4>{{ 'COMPANY_PAGE.LANDING_PROFILES.BRANDING_SECTION' | translate }}</h4>
                  <div class="landing-profile-modal-grid">
                    <div class="landing-profile-modal-field landing-profile-modal-grid__full">
                      <label
                        nz-checkbox
                        [nzChecked]="useCustomProfileLogo"
                        (nzCheckedChange)="onProfileLogoOverrideChange($event)"
                      >
                        {{ 'COMPANY_PAGE.LANDING_PROFILES.USE_CUSTOM_LOGO' | translate }}
                      </label>

                      <ng-container *ngIf="useCustomProfileLogo">
                        <nz-upload
                          [nzAction]="uploadUrl"
                          [nzData]="profileLogoUploadData"
                          (nzChange)="handleProfileLogoChange($event)"
                          [nzLimit]="1"
                          [nzAccept]="logoAcceptedExtensions"
                          [nzShowUploadList]="false"
                          [nzBeforeUpload]="beforeUpload"
                        >
                          <button nz-button type="button">
                            <span nz-icon nzType="upload"></span> {{ 'COMPANY_PAGE.UPLOAD_LOGO' | translate }}
                          </button>
                        </nz-upload>

                        <div class="logo-preview landing-profile-logo-preview" *ngIf="profileLogoPreviewState === 'ready' && profileLogoUrl">
                          <img
                            [src]="profileLogoUrl"
                            [alt]="'COMPANY_PAGE.LANDING_PROFILES.CUSTOM_LOGO_ALT' | translate"
                            class="company-logo-preview"
                          />
                        </div>

                        <div class="logo-preview logo-preview--loading landing-profile-logo-preview" *ngIf="profileLogoPreviewState === 'loading'">
                          <span nz-icon nzType="loading" nzTheme="outline"></span>
                          <span>{{ 'COMPANY_PAGE.LOGO_LOADING' | translate }}</span>
                        </div>

                        <button
                          *ngIf="landingProfileForm.get('logoUrl')?.value"
                          nz-button
                          nzType="link"
                          type="button"
                          (click)="onProfileLogoOverrideChange(false)"
                        >
                          {{ 'COMPANY_PAGE.LANDING_PROFILES.REMOVE_PROFILE_LOGO' | translate }}
                        </button>
                      </ng-container>
                    </div>

                    <div class="landing-profile-modal-field landing-profile-modal-grid__full">
                      <label
                        nz-checkbox
                        [nzChecked]="useCustomProfileThemeColor"
                        (nzCheckedChange)="onProfileThemeColorOverrideChange($event)"
                      >
                        {{ 'COMPANY_PAGE.LANDING_PROFILES.USE_CUSTOM_THEME_COLOR' | translate }}
                      </label>

                      <div class="palette-section" *ngIf="useCustomProfileThemeColor">
                        <ng-container *ngIf="profileLogoPreviewState === 'ready' && profileLogoUrl">
                        <div class="palette-header">
                          <div class="palette-title">{{ 'COMPANY_PAGE.PALETTE.TITLE' | translate }}</div>
                          <div class="palette-help" *ngIf="profileDetectedPalette.length">{{ 'COMPANY_PAGE.PALETTE.HELP' | translate }}</div>
                        </div>
                        <div class="palette-row" *ngIf="profileDetectedPalette.length">
                          <button
                            type="button"
                            class="palette-chip"
                            *ngFor="let color of profileDetectedPalette"
                            [style.background]="color"
                            [attr.aria-label]="('COMPANY_PAGE.PALETTE.SELECT_COLOR_ARIA' | translate:{ color: color })"
                            [title]="color"
                            [class.selected]="(landingProfileForm.get('themeColor')?.value || '').toUpperCase() === color.toUpperCase()"
                            (click)="onProfilePaletteColorSelect(color)"
                          ></button>
                        </div>
                        <div class="palette-empty" *ngIf="!profileDetectedPalette.length">
                          <span *ngIf="isDetectingProfilePalette">{{ 'COMPANY_PAGE.PALETTE.DETECTING' | translate }}</span>
                          <span *ngIf="!isDetectingProfilePalette && profilePaletteDetectionCompleted">{{ 'COMPANY_PAGE.PALETTE.NOT_AVAILABLE' | translate }}</span>
                        </div>
                        </ng-container>

                        <div class="custom-color-section">
                          <div class="custom-color-label">
                            {{ (profileLogoPreviewState === 'ready' && profileLogoUrl && profileDetectedPalette.length
                              ? 'COMPANY_PAGE.PALETTE.CUSTOM_COLOR_LABEL'
                              : 'COMPANY_PAGE.LANDING_PROFILES.CUSTOM_THEME_COLOR_LABEL') | translate }}
                            <span
                              nz-icon
                              nzType="info-circle"
                              class="info-icon"
                              nz-tooltip
                              [nzTooltipTitle]="'COMPANY_PAGE.PALETTE.CUSTOM_COLOR_TOOLTIP' | translate"
                            ></span>
                          </div>
                          <nz-form-item class="custom-color-picker-item">
                            <div
                              class="custom-color-chip"
                              [class.selected]="profileThemeColorSelectionSource === 'custom'"
                              [style.background-color]="getProfileCustomThemeColorPreview()"
                            >
                              <nz-color-picker
                                [formControl]="profileCustomThemeColorControl"
                                [nzAllowClear]="false"
                                [nzShowText]="false"
                                (mousedown)="onProfileCustomColorPickerUserIntent()"
                                (keydown)="onProfileCustomColorPickerUserIntent()"
                                (nzOnChange)="onProfileCustomColorPickerChange($event)"
                              ></nz-color-picker>
                            </div>
                          </nz-form-item>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="landing-profile-modal-section">
                  <h4>{{ 'COMPANY_PAGE.LANDING_PROFILES.QR_POSTER_TEMPLATE_SECTION' | translate }}</h4>
                  <p class="input-helper-text">{{ 'COMPANY_PAGE.LANDING_PROFILES.QR_POSTER_TEMPLATE_HELP' | translate }}</p>

                  <div *ngIf="landingProfileQrPosterTemplatesLoading" class="input-helper-text">
                    {{ 'COMPANY_PAGE.LANDING_PROFILES.QR_POSTER_TEMPLATE_LOADING' | translate }}
                  </div>

                  <ng-container *ngIf="!landingProfileQrPosterTemplatesLoading">
                    <nz-form-item *ngIf="landingProfileQrPosterTemplates.length" class="landing-profile-modal-field landing-profile-template-field">
                      <nz-form-label>{{ 'COMPANY_PAGE.LANDING_PROFILES.QR_POSTER_TEMPLATE_LABEL' | translate }}</nz-form-label>
                      <nz-form-control>
                        <nz-select class="landing-profile-template-select" formControlName="qrPosterTemplateId">
                          <nz-option
                            [nzLabel]="'COMPANY_PAGE.LANDING_PROFILES.QR_POSTER_TEMPLATE_INHERIT' | translate"
                            [nzValue]="landingProfileTemplateInheritValue"
                          ></nz-option>
                          <nz-option
                            *ngFor="let template of landingProfileQrPosterTemplates"
                            [nzLabel]="template.name"
                            [nzValue]="template.id"
                          ></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>

                    <div *ngIf="!landingProfileQrPosterTemplates.length" class="input-helper-text">
                      {{ 'COMPANY_PAGE.LANDING_PROFILES.QR_POSTER_TEMPLATE_EMPTY' | translate }}
                    </div>
                    <button nz-button nzType="default" type="button" (click)="openQrPosterTemplateEditor()">
                      <span nz-icon nzType="picture"></span>
                      {{ 'COMPANY_PAGE.LANDING_PROFILES.QR_POSTER_TEMPLATE_OPEN_EDITOR' | translate }}
                    </button>
                  </ng-container>
                </div>

                <div class="landing-profile-modal-section" *ngIf="editingLandingProfileId">
                  <h4>{{ 'COMPANY_PAGE.LANDING_PROFILES.SETTINGS_SECTION' | translate }}</h4>
                  <div class="landing-profile-modal-settings">
                    <label nz-checkbox formControlName="active" *ngIf="editingLandingProfileId">
                      {{ 'COMPANY_PAGE.LANDING_PROFILES.ACTIVE' | translate }}
                    </label>
                  </div>
                </div>
              </form>
            </ng-container>
          </nz-modal>
        </div>

        <!-- RIGHT: LOGO UPLOAD (unchanged) -->
        <div
          nz-col
          [nzXs]="24"
          [nzSm]="24"
          [nzMd]="8"
          [nzLg]="8"
          [nzXl]="7"
          class="centered-column logo-pane"
        >
          <div class="column-content" [class.logo-upload--error]="highlightLogoUpload">

            <div class="logo-upload-label">
              {{ 'COMPANY_PAGE.UPLOAD_LOGO' | translate }} <span class="required-asterisk-after">*</span>
            </div>
            <p class="logo-upload-instruction">{{ 'COMPANY_PAGE.LOGO_UPLOAD_INSTRUCTION' | translate }}</p>

            <nz-upload
              [nzAction]="uploadUrl"
              (nzChange)="handleLogoChange($event)"
              [nzLimit]="1"
              [nzAccept]="logoAcceptedExtensions"
              [nzShowUploadList]="false"
              [nzBeforeUpload]="beforeUpload"
            >
              <button nz-button>
                <span nz-icon nzType="upload"></span> {{ 'COMPANY_PAGE.UPLOAD_LOGO' | translate }}
              </button>
            </nz-upload>

            <div class="logo-validation-error" *ngIf="highlightLogoUpload">
              <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
              {{ 'COMPANY_PAGE.LOGO_REQUIRED_ERROR' | translate }}
            </div>
            <!-- Logo Preview Section -->
            <div
              class="logo-preview"
              *ngIf="logoPreviewState === 'ready' && logoUrl"
              [class.logo-preview--wide]="isLogoWide"
            >
              <img
                [src]="logoUrl"
                alt="Company Logo"
                class="company-logo-preview"
                (load)="onCompanyLogoLoad($event)"
              />
            </div>

            <div class="logo-preview logo-preview--loading" *ngIf="logoPreviewState === 'loading'">
              <span nz-icon nzType="loading" nzTheme="outline"></span>
              <span>{{ 'COMPANY_PAGE.LOGO_LOADING' | translate }}</span>
            </div>

            <div class="logo-preview-error" *ngIf="logoPreviewState === 'error'">
              <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
              <span>{{ 'COMPANY_PAGE.LOGO_LOAD_ERROR' | translate }}</span>
            </div>

            <div
              class="palette-section"
              *ngIf="hasCustomLogo && (logoPreviewState === 'loading' || logoPreviewState === 'ready')">
              <div class="palette-header">
                <div class="palette-title">
                  {{ 'COMPANY_PAGE.PALETTE.TITLE' | translate }}
                </div>
                <div class="palette-help">
                  {{ 'COMPANY_PAGE.PALETTE.HELP' | translate }}
                </div>
              </div>

              <div class="palette-row" *ngIf="detectedPalette?.length; else paletteEmpty">
                <button
                  type="button"
                  class="palette-chip"
                  *ngFor="let c of detectedPalette"
                  [style.background]="c"
                  [attr.aria-label]="('COMPANY_PAGE.PALETTE.SELECT_COLOR_ARIA' | translate:{ color: c })"
                  [title]="c"
                  [class.selected]="(companyForm.get('themeColor')?.value || '').toUpperCase() === c.toUpperCase()"
                  (click)="onPaletteColorSelect(c)"
                ></button>
              </div>

              <ng-template #paletteEmpty>
                <div class="palette-empty">
                  <span *ngIf="isDetectingPalette || logoPreviewState === 'loading'">
                    {{ 'COMPANY_PAGE.PALETTE.DETECTING' | translate }}
                  </span>
                  <span *ngIf="!isDetectingPalette && paletteDetectionCompleted && logoPreviewState === 'ready'">
                    {{ 'COMPANY_PAGE.PALETTE.NOT_AVAILABLE' | translate }}
                  </span>
                </div>
          </ng-template>

          <div class="custom-color-section">
            <div class="custom-color-label">
              {{ 'COMPANY_PAGE.PALETTE.CUSTOM_COLOR_LABEL' | translate }}
              <span
                nz-icon
                nzType="info-circle"
                class="info-icon"
                nz-tooltip
                [nzTooltipTitle]="'COMPANY_PAGE.PALETTE.CUSTOM_COLOR_TOOLTIP' | translate"
              ></span>
            </div>
            <nz-form-item class="custom-color-picker-item">
              <nz-form-control [nzErrorTip]="themeColorErrTpl">
                <div
                  class="custom-color-chip"
                  [class.selected]="themeColorSelectionSource === 'custom'"
                  [style.background-color]="getCustomThemeColorPreview()"
                >
                  <nz-color-picker
                    [formControl]="customThemeColorControl"
                    [nzAllowClear]="false"
                    [nzShowText]="false"
                    (mousedown)="onCustomColorPickerUserIntent()"
                    (keydown)="onCustomColorPickerUserIntent()"
                    (nzOnChange)="onCustomColorPickerChange($event)">
                  </nz-color-picker>
                </div>
                <ng-template #themeColorErrTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    {{ 'COMPANY_PAGE.THEME_COLOR_REQUIRED_ERROR' | translate }}
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
            <div class="theme-color-validation-error" *ngIf="showThemeColorRequiredError">
              <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
              {{ 'COMPANY_PAGE.THEME_COLOR_REQUIRED_ERROR' | translate }}
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
      <!-- SAVE BUTTON (same for all tabs) -->
      <div nz-row nzGutter="16" class="form-buttons">
        <div nz-col nzSpan="14">
          <button
            type="button"
            nz-button
            nzType="primary"
            class="button-save"
            [ngClass]="{ 'form-modified': formModified }"
            [nzLoading]="isSaving"
            [disabled]="isSaving"
            (click)="saveCompanyInfo()"
          >
            {{ 'COMPANY_PAGE.SAVE' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #addressFormatPopover>
  <div class="address-format-help">
    <p>{{ 'COMMON.ADDRESS_FORMAT_HELP_INTRO' | translate }}</p>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_NORMAL' | translate }}</strong>
      <code>Musterstraße 12, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_RANGE' | translate }}</strong>
      <code>Musterstraße 8 - 10, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_HOUSE_NUMBERS' | translate }}</strong>
      <code>Muster Straße 12/14 + 16A, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_STREET' | translate }}</strong>
      <code>Musterstraße 12 /  Musterweg 3, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_ENTRIES' | translate }}</strong>
      <code>Musterstraße 12,  Musterweg 3, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_ZIP' | translate }}</strong>
      <code>Muster Straße 63 /  Musterweg 9,  10010 Musterort   / 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_SHARED_CITY' | translate }}</strong>
      <code>Muster Str. 18 /  Musterweg 1-3, 12333 / 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_SPECIAL_CHARS' | translate }}</strong>
      <code>Rue de Mustér 5, 12345 Musterort</code>
    </div>

    <p class="address-format-note">
      {{ 'COMMON.ADDRESS_FORMAT_HELP_NOTE' | translate }}
      <br />
      <em>{{ 'COMMON.ADDRESS_FORMAT_HELP_INVALID_EXAMPLE' | translate }}</em>
    </p>
  </div>
</ng-template>
